(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(75424);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 75424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/common/components/AppLayout/index.tsx + 7 modules
var AppLayout = __webpack_require__(3907);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(40794);
// EXTERNAL MODULE: ../../libs/data-access/src/index.ts + 57 modules
var src = __webpack_require__(97967);
// EXTERNAL MODULE: ../../libs/shared/ui/src/index.ts + 240 modules
var ui_src = __webpack_require__(3592);
// EXTERNAL MODULE: ../../libs/shared/util/src/index.ts + 8 modules
var util_src = __webpack_require__(12105);
// EXTERNAL MODULE: ../../node_modules/antd/es/spin/index.js + 5 modules
var spin = __webpack_require__(76219);
// EXTERNAL MODULE: ../../node_modules/antd/es/space/index.js + 3 modules
var space = __webpack_require__(55806);
// EXTERNAL MODULE: ../../node_modules/antd/es/segmented/index.js + 11 modules
var segmented = __webpack_require__(44345);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(72396);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@ant-design/plots/es/components/base/index.js + 1042 modules
var base = __webpack_require__(49395);
;// CONCATENATED MODULE: ../../node_modules/@ant-design/plots/es/components/pie/index.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var PieChart = (0,react.forwardRef)(function (props, ref) { return react.createElement(base/* BaseChart */.P, __assign({}, props, { chartType: "Pie", ref: ref })); });
/* harmony default export */ var pie = (PieChart);

// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(3842);
// EXTERNAL MODULE: ../../node_modules/antd/es/card/index.js + 4 modules
var card = __webpack_require__(11530);
// EXTERNAL MODULE: ../../node_modules/antd/es/date-picker/index.js + 103 modules
var date_picker = __webpack_require__(11288);
// EXTERNAL MODULE: ../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(28879);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/features/dashboard/components/CompaniesGraphs/PitchUploadedStats.tsx








function PitchUploadedStats() {
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { t: tcommon  } = (0,useTranslation/* default */.Z)("common");
    const [data, setData] = (0,react.useState)([]);
    const [date, setDate] = (0,react.useState)(dayjs_min_default()());
    const [getSearchChallengeData, { loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_INSTITUTIONS_PITCH_UPLOADED_STATS */.kjL, {
        onCompleted: (data)=>{
            const newData = [];
            const list = data.getCompanyPitchStatistics;
            if (list && list.length > 0) {
                const lastItem = list[list.length - 1];
                newData.push({
                    type: t("without_pitches"),
                    count: lastItem.unpitched
                });
                newData.push({
                    type: t("with_pitches"),
                    count: lastItem.pitched
                });
            }
            setData(newData);
        }
    });
    const monthNames = (0,react.useMemo)(()=>[
            tcommon("Jan"),
            tcommon("Feb"),
            tcommon("Mar"),
            tcommon("Apr"),
            tcommon("May"),
            tcommon("Jun"),
            tcommon("Jul"),
            tcommon("Aug"),
            tcommon("Sep"),
            tcommon("Oct"),
            tcommon("Nov"),
            tcommon("Dec")
        ], [
        tcommon
    ]);
    (0,react.useEffect)(()=>{
        getSearchChallengeData({
            variables: {
                endDate: date === null || date === void 0 ? void 0 : date.format("YYYY-MM")
            }
        });
    }, [
        date,
        getSearchChallengeData
    ]);
    const config = {
        data: data,
        radius: 0.75,
        legend: {
            color: {
                position: "bottom",
                flipPage: false,
                layout: {
                    justifyContent: "center",
                    alignItems: "center"
                }
            }
        },
        loading: loading,
        angleField: "count",
        colorField: "type",
        scale: {
            color: {
                range: [
                    "#58AFFF",
                    "#63E063"
                ]
            }
        },
        interaction: {
            tooltip: {
                name: "type",
                render: (event, param)=>{
                    let { title , items  } = param;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    t("count"),
                                    ": ",
                                    items[0].value
                                ]
                            })
                        ]
                    });
                }
            }
        },
        label: {
            position: "outside",
            style: {
                fontFamily: "Lufga",
                fill: "rgba(0, 0, 0, 0.65)"
            },
            labelHeight: 28,
            text: (d)=>{
                return "".concat(d.type, "\n").concat((d.count / data.reduce((acc, curr)=>acc + curr.count, 0) * 100).toFixed(2), "%");
            }
        },
        color: (param)=>{
            let { type  } = param;
            switch(type){
                case "Without pitches":
                    return "#58AFFF";
                case "With pitches":
                    return "#63E063";
                default:
                    return "#1890FF";
            }
        },
        xAxis: {
            label: {
                style: {
                    fontFamily: "Lufga"
                },
                autoHide: true,
                autoRotate: false,
                formatter: (v)=>{
                    const monthNames = [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ];
                    const monthIndex = parseInt(v.split("-")[1], 10) - 1;
                    return monthNames[monthIndex];
                }
            }
        },
        yAxis: {
            label: {
                style: {
                    fontFamily: "Lufga"
                }
            }
        },
        meta: {
            type: {
                alias: "Challenge"
            }
        }
    };
    const onChange = (date, dateString)=>{
        setDate(date);
    };
    const disabledDate = (current)=>{
        return current && current > dayjs_min_default()().endOf("month");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-sm text-gray-900 font-medium",
                            children: t("companies_with_pitches")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(date_picker/* default */.Z, {
                                style: {
                                    width: "150px",
                                    borderRadius: 20
                                },
                                onChange: onChange,
                                picker: "month",
                                value: date,
                                disabledDate: disabledDate
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(pie, {
                    ...config
                }, "pitch-uploaded-stats")
            ]
        })
    });
}
/* harmony default export */ var CompaniesGraphs_PitchUploadedStats = (PitchUploadedStats);

// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/features/dashboard/components/CompaniesGraphs/PopularCountryStats.tsx








const WorldMapDynamic = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(156), __webpack_require__.e(2538), __webpack_require__.e(7827), __webpack_require__.e(5293), __webpack_require__.e(2371), __webpack_require__.e(1819)]).then(__webpack_require__.bind(__webpack_require__, 21819)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(21819)
            ]
    },
    ssr: false
});
function PopularCountryStats(param) {
    let { className  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { data , loading  } = (0,useQuery/* useQuery */.a)(src/* GET_COMPANY_COUNT_BY_LOCATION */.Cyh, {
        variables: {
            startDate: dayjs_min_default()().subtract(1, "month").format("YYYY-MM-DD"),
            endDate: dayjs_min_default()().format("YYYY-MM-DD")
        }
    });
    const stats = (0,react.useMemo)(()=>{
        var ref;
        return (data === null || data === void 0 ? void 0 : (ref = data.companyCountByLocation) === null || ref === void 0 ? void 0 : ref.filter((item)=>item.location).map((item)=>({
                country: item.location,
                count: item.all
            })).sort((a, b)=>b.count - a.count)) || [];
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        className: "".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center gap-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-sm text-gray-900 font-medium",
                        children: t("companies_by_country")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: 400
                    },
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Loading..."
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WorldMapDynamic, {
                            loading: loading,
                            stats: stats
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: stats.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm text-gray-900 font-normal",
                                    children: item.country
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm text-gray-900 font-normal",
                                    children: item.count
                                })
                            ]
                        }, item.country))
                })
            ]
        })
    });
}
/* harmony default export */ var CompaniesGraphs_PopularCountryStats = (PopularCountryStats);

// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/CaretUpOutlined.js + 1 modules
var CaretUpOutlined = __webpack_require__(99852);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/CaretDownOutlined.js + 1 modules
var CaretDownOutlined = __webpack_require__(23272);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/SearchOutlined.js + 1 modules
var SearchOutlined = __webpack_require__(39264);
// EXTERNAL MODULE: ../../node_modules/antd/es/select/index.js
var es_select = __webpack_require__(51747);
// EXTERNAL MODULE: ../../node_modules/antd/es/input/index.js + 6 modules
var input = __webpack_require__(15734);
// EXTERNAL MODULE: ../../node_modules/antd/es/table/index.js + 127 modules
var table = __webpack_require__(21041);
;// CONCATENATED MODULE: ./src/features/dashboard/components/CompaniesGraphs/PopularInsightsStats.tsx








const { Option  } = es_select/* default */.Z;
const PopularInsightsStats = ()=>{
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const [filterPeriod, setFilterPeriod] = (0,react.useState)("week");
    const [searchText, setSearchText] = (0,react.useState)("");
    const [data, setData] = (0,react.useState)([]);
    const [prevData, setPrevData] = (0,react.useState)([]);
    const [getData, { loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_COMPANY_COUNT_BY_LOCATION */.Cyh, {
        fetchPolicy: "no-cache"
    });
    (0,react.useEffect)(()=>{
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        getData,
        filterPeriod
    ]);
    const getDateRange = (period, endDate)=>{
        let startDate = dayjs_min_default()();
        switch(period){
            case "week":
                startDate = endDate.clone().subtract(7, "day");
                break;
            case "month":
                startDate = endDate.clone().subtract(1, "month");
                break;
            case "3months":
                startDate = endDate.clone().subtract(3, "month");
                break;
            case "year":
                startDate = endDate.clone().subtract(1, "year");
                break;
        }
        return {
            startDate: startDate.format("YYYY-MM-DD"),
            endDate: endDate.format("YYYY-MM-DD")
        };
    };
    const fetchData = async ()=>{
        const currentEndDate = dayjs_min_default()();
        const { startDate , endDate  } = getDateRange(filterPeriod, currentEndDate);
        await getData({
            variables: {
                startDate,
                endDate
            }
        }).then((param)=>{
            let { data  } = param;
            setData(data === null || data === void 0 ? void 0 : data.companyCountByLocation);
        });
        // Get previous period data
        const prevEndDate = dayjs_min_default()(startDate);
        const { startDate: startDate1 , endDate: endDate1  } = getDateRange(filterPeriod, prevEndDate);
        await getData({
            variables: {
                startDate: startDate1,
                endDate: endDate1
            }
        }).then((param)=>{
            let { data  } = param;
            setPrevData(data === null || data === void 0 ? void 0 : data.companyCountByLocation);
        });
    };
    const getPercentChange = (value, prevValue)=>{
        if (prevValue === 0 && value === 0) {
            return 0;
        }
        if (prevValue === 0) {
            return 100;
        }
        return (value - prevValue) / prevValue * 100;
    };
    const stats = (0,react.useMemo)(()=>{
        return data.filter((item)=>item.location).map((item)=>{
            const prevItem = prevData.find((prevItem)=>prevItem.location === item.location);
            return {
                country: item.location,
                companies: item.count,
                change: getPercentChange(item.count, (prevItem === null || prevItem === void 0 ? void 0 : prevItem.count) || 0)
            };
        });
    }, [
        data,
        prevData
    ]);
    const filteredStats = (0,react.useMemo)(()=>{
        return stats.filter((item)=>item.country.toLowerCase().includes(searchText.toLowerCase()));
    }, [
        stats,
        searchText
    ]);
    const columns = [
        {
            title: t("country"),
            dataIndex: "country",
            key: "country",
            width: "60%"
        },
        {
            title: t("companies"),
            dataIndex: "companies",
            key: "companies",
            width: "20%"
        },
        {
            title: t("percent_change"),
            dataIndex: "change",
            key: "change",
            width: "20%",
            render: (change)=>{
                const isPositive = change >= 0;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "inline-block px-2 py-1 rounded-full font-medium text-sm ".concat(isPositive ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"),
                    children: [
                        isPositive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretUpOutlined/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretDownOutlined/* default */.Z, {}),
                        " ",
                        Math.round(change),
                        "%"
                    ]
                });
            }
        }
    ];
    const handleFilterChange = (key)=>{
        setFilterPeriod(key);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col space-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-sm text-gray-900 font-medium",
                            children: t("company_growth_by_country")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex space-x-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                    placeholder: t("country_name"),
                                    value: searchText,
                                    onChange: (e)=>setSearchText(e.target.value),
                                    className: "flex-grow",
                                    style: {
                                        height: "40px"
                                    },
                                    suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchOutlined/* default */.Z, {
                                        style: {
                                            color: "rgba(0,0,0,.45)"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_select/* default */.Z, {
                                    value: filterPeriod,
                                    onChange: handleFilterChange,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                                            value: "week",
                                            children: t("last_7_days")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                                            value: "month",
                                            children: t("last_30_days")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                                            value: "3months",
                                            children: t("last_3_months")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                                            value: "year",
                                            children: t("last_year")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default */.Z, {
                    columns: columns,
                    dataSource: filteredStats,
                    loading: loading,
                    pagination: false,
                    rowKey: "country"
                })
            ]
        })
    });
};
/* harmony default export */ var CompaniesGraphs_PopularInsightsStats = (PopularInsightsStats);

// EXTERNAL MODULE: ../../node_modules/@ant-design/plots/es/components/bar/index.js
var bar = __webpack_require__(27955);
;// CONCATENATED MODULE: ./src/features/dashboard/components/CompaniesGraphs/PopularRegionStats.tsx







function PopularRegionStats(param) {
    let { className  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { data , loading  } = (0,useQuery/* useQuery */.a)(src/* GET_INSTITUTIONS_BY_REGION */.u4Y);
    const highestRegion = (0,react.useMemo)(()=>{
        if (!(data === null || data === void 0 ? void 0 : data.companyCountByRegion) || data.companyCountByRegion.length === 0) return "";
        return data.companyCountByRegion.reduce((max, item)=>item.count > max.count ? item : max).region;
    }, [
        data
    ]);
    const formattedData = (0,react.useMemo)(()=>{
        return data === null || data === void 0 ? void 0 : data.companyCountByRegion.map((item)=>({
                ...item,
                color: item.region === highestRegion ? "#63E063" : "#58AFFF"
            }));
    }, [
        data,
        highestRegion
    ]);
    const config = {
        data: formattedData || [],
        loading: loading,
        xField: "region",
        yField: "count",
        paddingRight: 20,
        colorField: "color",
        scale: {
            color: {
                range: [
                    "#63E063",
                    "#58AFFF"
                ]
            }
        },
        interaction: {
            tooltip: {
                name: "region",
                render: (event, param)=>{
                    let { title , items  } = param;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    t("count"),
                                    ": ",
                                    items[0].value
                                ]
                            })
                        ]
                    });
                }
            }
        },
        label: {
            text: "count",
            position: "right",
            textAlign: "start",
            dx: 8,
            style: {
                fill: "rgba(0, 0, 0, 0.65)",
                fontFamily: "Lufga"
            }
        },
        xAxis: {
            label: {
                autoHide: true,
                autoRotate: false,
                style: {
                    fontFamily: "Lufga",
                    fill: "rgba(0, 0, 0, 0.65)",
                    textAlign: "right"
                }
            }
        },
        yAxis: {
            label: {
                style: {
                    fontFamily: "Lufga"
                }
            }
        },
        legend: {
            position: "bottom",
            flipPage: false
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: t("companies_by_region")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-gray-700 font-normal",
                        children: t("user_region_double_counted")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bar/* default */.Z, {
                ...config
            }, "companies-by-region")
        ]
    });
}
/* harmony default export */ var CompaniesGraphs_PopularRegionStats = (PopularRegionStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/CompaniesGraphs/PopularTopicsStats.tsx







function PopularTopicsStats(param) {
    let { className  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const [data, setData] = (0,react.useState)([]);
    const [selectedTopics, setSelectedTopics] = (0,react.useState)([]);
    const [getData, { loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_INSTITUTIONS_BY_TOPICS */.XPE, {
        onCompleted: (data)=>{
            setData(data.companyCountByTopic);
        }
    });
    (0,react.useEffect)(()=>{
        getData({
            variables: {
                order: true
            }
        });
    }, [
        getData
    ]);
    const filteredData = (0,react.useMemo)(()=>{
        if (selectedTopics.length === 0) return data;
        return data.filter((item)=>selectedTopics.includes(item.topic));
    }, [
        data,
        selectedTopics
    ]);
    const config = {
        data: filteredData,
        xField: "count",
        yField: "topic",
        color: "#3BA1FF",
        appendPadding: [
            0,
            20,
            0,
            0
        ],
        yAxis: {
            label: {
                formatter: (value)=>value.length > 30 ? value.slice(0, 30) + "..." : value,
                style: {
                    fontFamily: "Lufga",
                    fill: "rgba(0, 0, 0, 0.65)",
                    textAlign: "right"
                }
            }
        },
        scale: {
            color: {
                range: [
                    "#58AFFF"
                ]
            }
        },
        axis: {
            x: {
                label: {
                    style: {
                        fontFamily: "Lufga",
                        fill: "rgba(0, 0, 0, 0.65)",
                        textAlign: "right"
                    }
                },
                labelFormatter: (value)=>value.length > 30 ? value.slice(0, 30) + "..." : value
            }
        },
        label: {
            text: "count",
            position: "right",
            textAlign: "start",
            dx: 8,
            style: {
                fill: "rgba(0, 0, 0, 0.65)",
                fontFamily: "Lufga"
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        className: "".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-sm text-gray-900 font-medium",
                            children: t("companies_by_topics")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                                mode: "multiple",
                                optionFilterProp: "label",
                                style: {
                                    width: 300
                                },
                                placeholder: t("select_topics"),
                                value: selectedTopics,
                                onChange: setSelectedTopics,
                                options: data.map((item)=>({
                                        value: item.topic,
                                        label: item.topic
                                    })),
                                maxTagCount: "responsive",
                                allowClear: true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bar/* default */.Z, {
                    loading: loading,
                    ...config
                })
            ]
        })
    });
}
/* harmony default export */ var CompaniesGraphs_PopularTopicsStats = (PopularTopicsStats);

// EXTERNAL MODULE: ../../node_modules/@ant-design/plots/es/components/line/index.js
var line = __webpack_require__(98328);
;// CONCATENATED MODULE: ./src/features/dashboard/components/CompaniesGraphs/TotalCompaniesStats.tsx









const { RangePicker  } = date_picker/* default */.Z;
const COLOR_PLATE_10 = [
    "#00CC00",
    "#0273EA",
    "#B1BDC9",
    "#7AC4FC",
    "#C5F1BB",
    "#A3B1BF",
    "#8B8B8B",
    "#525355"
];
const TotalCompaniesStats = ()=>{
    var ref;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { t: tcommon  } = (0,useTranslation/* default */.Z)("common");
    const [data, setData] = (0,react.useState)([]);
    const endDate = dayjs_min_default()();
    const startDate = endDate.subtract(3, "month");
    const [dates, setDates] = (0,react.useState)([
        startDate.format("YYYY-MM-DD"),
        endDate.format("YYYY-MM-DD")
    ]);
    const [selectedItems, setSelectedItems] = (0,react.useState)([]);
    const { data: dataTotal  } = (0,useQuery/* useQuery */.a)(src/* GET_TOTAL_COMPANY_COUNT */.FQi);
    const [getData, { loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_COMPANY_STATISTICS */.G0I, {
        fetchPolicy: "no-cache",
        onCompleted: (data)=>{
            setData(convertJsonStructure(data.companyStatisticsGraph));
        }
    });
    const monthNames = (0,react.useMemo)(()=>[
            tcommon("Jan"),
            tcommon("Feb"),
            tcommon("Mar"),
            tcommon("Apr"),
            tcommon("May"),
            tcommon("Jun"),
            tcommon("Jul"),
            tcommon("Aug"),
            tcommon("Sep"),
            tcommon("Oct"),
            tcommon("Nov"),
            tcommon("Dec")
        ], [
        tcommon
    ]);
    const getLabel = (value)=>{
        return (0,util_src/* getLinkLabel */.en)(value === null || value === void 0 ? void 0 : value.toLowerCase());
    };
    function convertJsonStructure(input) {
        if (!input.length) return [];
        const result = input.flatMap((param)=>{
            let { date , values  } = param;
            const totalCount = values.reduce((sum, param)=>{
                let { count  } = param;
                return sum + count;
            }, 0);
            const individualEntries = values.map((param)=>{
                let { type , count  } = param;
                return {
                    date,
                    type: getLabel(type),
                    count
                };
            });
            return [
                {
                    date,
                    type: "All",
                    count: totalCount
                },
                ...individualEntries
            ];
        });
        return result.sort((a, b)=>new Date(a.date).getTime() - new Date(b.date).getTime());
    }
    (0,react.useEffect)(()=>{
        if (dates.length) {
            getData({
                variables: {
                    input: {
                        startDate: dates[0],
                        endDate: dates[1]
                    }
                }
            });
        }
    }, [
        dates,
        getData
    ]);
    const defaultSelectedItems = (0,react.useMemo)(()=>{
        if (data.length > 0) {
            return data.map((item)=>item.type);
        }
        return [];
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        setSelectedItems(defaultSelectedItems);
    }, [
        defaultSelectedItems
    ]);
    const config = (0,react.useMemo)(()=>{
        return {
            data: data,
            xField: "date",
            yField: "count",
            seriesField: "type",
            colorField: "type",
            loading: loading,
            yAxis: {
                label: {
                    style: {
                        fontFamily: "Lufga"
                    }
                }
            },
            xAxis: {
                label: {
                    style: {
                        fontFamily: "Lufga"
                    },
                    labelFormatter: (v)=>{
                        const monthIndex = parseInt(v.split("-")[1], 10) - 1;
                        return monthNames[monthIndex];
                    }
                }
            },
            legend: {
                color: {
                    position: "bottom",
                    autoWrap: true,
                    itemMarker: "square",
                    style: {
                        fontSize: 14,
                        fontFamily: "Lufga"
                    },
                    layout: {
                        justifyContent: "center",
                        alignItems: "center"
                    }
                }
            },
            onReady: (param)=>{
                let { chart  } = param;
                chart.on("legend:filter", (e)=>{
                    var ref;
                    if (e === null || e === void 0 ? void 0 : (ref = e.data) === null || ref === void 0 ? void 0 : ref.values) {
                        var ref1;
                        const values = e === null || e === void 0 ? void 0 : (ref1 = e.data) === null || ref1 === void 0 ? void 0 : ref1.values;
                        setSelectedItems([
                            ...values
                        ]);
                    }
                });
            },
            interactions: [
                {
                    type: "legend-filter"
                }
            ],
            animation: {
                appear: {
                    animation: "path-in",
                    duration: 100
                }
            },
            label: {
                text: "count",
                position: "top",
                textAlign: "center",
                dy: -10,
                style: {
                    fontFamily: "Lufga"
                }
            },
            scale: {
                color: {
                    range: COLOR_PLATE_10
                }
            }
        };
    }, [
        data,
        loading,
        monthNames
    ]);
    const handleChange = (dates, dateStrings)=>{
        if (dates) {
            setDates([
                dateStrings[0],
                dateStrings[1]
            ]);
        }
    };
    const visibleTotal = (0,react.useMemo)(()=>{
        if (selectedItems.includes("All")) {
            return data.filter((item)=>item.type === "All").reduce((acc, curr)=>acc + curr.count, 0);
        } else {
            return data.filter((item)=>item.type !== "All" && selectedItems.includes(item.type)).reduce((acc, curr)=>acc + curr.count, 0);
        }
    }, [
        data,
        selectedItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row flex-wrap justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "flex items-center flex-wrap gap-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("total_during_period")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-gray-700 font-medium",
                                children: [
                                    "/ ",
                                    t("total_all_time")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RangePicker, {
                            onChange: handleChange,
                            defaultValue: [
                                dayjs_min_default()(dates[0]),
                                dayjs_min_default()(dates[1])
                            ],
                            style: {
                                borderRadius: 20
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center flex-wrap gap-1 my-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-gray-900 text-3xl",
                        children: visibleTotal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-gray-700 text-2xl",
                        children: [
                            "/ ",
                            dataTotal === null || dataTotal === void 0 ? void 0 : (ref = dataTotal.totalCompanyCount) === null || ref === void 0 ? void 0 : ref.toLocaleString()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(line/* default */.Z, {
                ...config
            })
        ]
    });
};
/* harmony default export */ var CompaniesGraphs_TotalCompaniesStats = (TotalCompaniesStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/CompaniesGraphs/index.tsx







function CompaniesGraphs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid md:grid-cols-2 gap-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesGraphs_TotalCompaniesStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesGraphs_PitchUploadedStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesGraphs_PopularCountryStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesGraphs_PopularInsightsStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesGraphs_PopularTopicsStats, {
                className: "md:col-span-2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesGraphs_PopularRegionStats, {
                className: "md:col-span-2"
            })
        ]
    });
}
/* harmony default export */ var components_CompaniesGraphs = (CompaniesGraphs);

// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/DownOutlined.js + 1 modules
var DownOutlined = __webpack_require__(63610);
// EXTERNAL MODULE: ../../node_modules/antd/es/dropdown/index.js + 5 modules
var dropdown = __webpack_require__(88701);
// EXTERNAL MODULE: ../../node_modules/antd/es/button/index.js + 41 modules
var es_button = __webpack_require__(25663);
;// CONCATENATED MODULE: ./src/features/dashboard/components/IdeasGraphs/IdeaAreaStats.tsx








function IdeaAreaStats(param) {
    let { className  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const [data, setData] = (0,react.useState)([]);
    const [sortOption, setSortOption] = (0,react.useState)({
        key: "HL",
        label: t("highest_to_lowest")
    });
    const [filter, setFilter] = (0,react.useState)([
        "DRAFT",
        "PUBLISHED",
        "HIDDEN",
        "REPORTED"
    ]);
    const [areaFilter, setAreaFilter] = (0,react.useState)([]);
    const [getIdeaAreas, { loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_IDEA_BUSINESS_AREA */.LbB, {
        fetchPolicy: "no-cache",
        onCompleted: (data)=>{
            setData(data.dashboardTopIdeaAreas);
        }
    });
    const sortOptions = (0,react.useMemo)(()=>[
            {
                key: "HL",
                label: t("highest_to_lowest")
            },
            {
                key: "LH",
                label: t("lowest_to_highest")
            }
        ], [
        t
    ]);
    const filterOptions = (0,react.useMemo)(()=>[
            {
                label: t("drafted"),
                value: "DRAFT"
            },
            {
                label: t("published"),
                value: "PUBLISHED"
            },
            {
                label: t("hidden"),
                value: "HIDDEN"
            },
            {
                label: t("reported"),
                value: "REPORTED"
            }
        ], [
        t
    ]);
    (0,react.useEffect)(()=>{
        const sortedData = [
            ...data
        ].sort((a, b)=>{
            if (sortOption.key === "HL") {
                return b.count - a.count;
            } else {
                return a.count - b.count;
            }
        });
        setData(sortedData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sortOption
    ]);
    const config = {
        data: data,
        xField: "name",
        yField: "count",
        color: "#2888ED",
        paddingRight: 20,
        label: {
            text: "count",
            position: "right",
            textAlign: "start",
            dx: 8,
            style: {
                fontFamily: "Lufga"
            }
        },
        yAxis: {
            label: {
                style: {
                    fontFamily: "Lufga",
                    fill: "rgba(0, 0, 0, 0.65)",
                    textAlign: "right"
                },
                labelFormatter: (value)=>{
                    const str = value.toString();
                    if (str.length > 20) {
                        return str.slice(0, 20) + "...";
                    }
                    return str;
                }
            }
        }
    };
    const handleFilterChange = (value)=>{
        setFilter(value);
    };
    (0,react.useEffect)(()=>{
        getIdeaAreas({
            variables: {
                statuses: filter
            }
        });
    }, [
        filter,
        getIdeaAreas
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        className: "".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-sm text-gray-900 font-medium",
                            children: t("idea_by_business_functional_area")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* default */.Z, {
                                menu: {
                                    items: sortOptions.map((item)=>({
                                            ...item,
                                            onClick: ()=>setSortOption(item)
                                        }))
                                },
                                placement: "bottomRight",
                                trigger: [
                                    "click"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_button/* default */.ZP, {
                                    shape: "round",
                                    children: [
                                        sortOption.label,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined/* default */.Z, {})
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex space-x-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                            onChange: handleFilterChange,
                            options: filterOptions,
                            value: filter,
                            placeholder: "",
                            allowClear: true,
                            mode: "multiple",
                            optionFilterProp: "label",
                            style: {
                                width: "100%"
                            },
                            maxTagCount: "responsive"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                            onChange: (value)=>setAreaFilter(value),
                            options: data === null || data === void 0 ? void 0 : data.map((item)=>({
                                    label: item.name,
                                    value: item.name
                                })),
                            value: areaFilter,
                            placeholder: t("filter_by_business_functional_area"),
                            allowClear: true,
                            mode: "multiple",
                            optionFilterProp: "label",
                            style: {
                                width: "100%"
                            },
                            maxTagCount: "responsive"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bar/* default */.Z, {
                    loading: loading,
                    ...config,
                    data: data === null || data === void 0 ? void 0 : data.filter((item)=>{
                        return areaFilter.length === 0 || areaFilter.includes(item === null || item === void 0 ? void 0 : item.name);
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var IdeasGraphs_IdeaAreaStats = (IdeaAreaStats);

// EXTERNAL MODULE: ../../node_modules/@ant-design/plots/es/components/column/index.js
var column = __webpack_require__(30869);
;// CONCATENATED MODULE: ./src/features/dashboard/components/IdeasGraphs/PopularRegionStats.tsx







const filterOptions = [
    {
        label: "Drafted",
        value: "DRAFT"
    },
    {
        label: "Published",
        value: "PUBLISHED"
    },
    {
        label: "Hidden",
        value: "HIDDEN"
    },
    {
        label: "Reported",
        value: "REPORTED"
    }
];
function PopularRegionStats_PopularRegionStats() {
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const [filter, setFilter] = (0,react.useState)([
        "DRAFT",
        "PUBLISHED",
        "HIDDEN",
        "REPORTED"
    ]);
    const [getIdeaRegions, { data , loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_IDEA_REGION */.v4_, {
        fetchPolicy: "no-cache"
    });
    const highestRegion = (0,react.useMemo)(()=>{
        if (!(data === null || data === void 0 ? void 0 : data.dashboardTopIdeaRegions) || data.dashboardTopIdeaRegions.length === 0) return "";
        return data.dashboardTopIdeaRegions.reduce((max, item)=>item.count > max.count ? item : max).name;
    }, [
        data
    ]);
    const formattedData = (0,react.useMemo)(()=>{
        return data === null || data === void 0 ? void 0 : data.dashboardTopIdeaRegions.map((item)=>({
                ...item,
                color: item.name === highestRegion ? "green" : "blue"
            }));
    }, [
        data,
        highestRegion
    ]);
    const config = {
        data: formattedData || [],
        xField: "name",
        yField: "count",
        appendPadding: [
            20,
            0,
            0,
            0
        ],
        color: (param)=>{
            let { name  } = param;
            return name === highestRegion ? "#63E063" : "#2888ED";
        },
        xAxis: {
            label: {
                formatter: (value)=>value.length > 30 ? value.slice(0, 30) + "..." : value,
                style: {
                    fontFamily: "Lufga",
                    fill: "rgba(0, 0, 0, 0.65)",
                    textAlign: "right"
                }
            }
        },
        yAxis: {
            label: {
                style: {
                    fontFamily: "Lufga",
                    fill: "rgba(0, 0, 0, 0.65)",
                    textAlign: "right"
                }
            }
        },
        meta: {
            type: {
                alias: t("region")
            },
            count: {
                alias: t("idea_count")
            }
        },
        loading: loading,
        label: {
            text: "count",
            position: "top",
            textAlign: "center",
            dy: -15,
            style: {
                fill: "rgba(0, 0, 0, 0.65)",
                fontFamily: "Lufga"
            }
        },
        interaction: {
            tooltip: {
                name: "name",
                render: (event, param)=>{
                    let { title , items  } = param;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    t("count"),
                                    ": ",
                                    items[0].value
                                ]
                            })
                        ]
                    });
                }
            }
        }
    };
    (0,react.useEffect)(()=>{
        getIdeaRegions({
            variables: {
                statuses: filter
            }
        });
    }, [
        filter,
        getIdeaRegions
    ]);
    const handleFilterChange = (value)=>{
        setFilter(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: t("idea_by_region")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                        onChange: handleFilterChange,
                        options: filterOptions,
                        value: filter,
                        placeholder: "",
                        allowClear: true,
                        mode: "multiple",
                        style: {
                            width: "100%"
                        },
                        maxTagCount: "responsive",
                        optionFilterProp: "label"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(column/* default */.Z, {
                ...config
            })
        ]
    });
}
/* harmony default export */ var IdeasGraphs_PopularRegionStats = (PopularRegionStats_PopularRegionStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/IdeasGraphs/PopularTopicsStats.tsx








function PopularTopicsStats_PopularTopicsStats(param) {
    let { className  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const [data, setData] = (0,react.useState)([]);
    const [filter, setFilter] = (0,react.useState)([
        "DRAFT",
        "PUBLISHED",
        "HIDDEN",
        "REPORTED"
    ]);
    const [topicFilter, setTopicFilter] = (0,react.useState)([]);
    const [sortOption, setSortOption] = (0,react.useState)({
        key: "HL",
        label: t("highest_to_lowest")
    });
    const [getIdeaTopics, { loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_IDEA_TOPICS */.jss, {
        fetchPolicy: "no-cache",
        onCompleted: (data)=>{
            const sortedData = sortData(data.dashboardTopIdeaTopics, sortOption.key);
            setData(sortedData);
        }
    });
    const sortOptions = (0,react.useMemo)(()=>[
            {
                key: "HL",
                label: t("highest_to_lowest")
            },
            {
                key: "LH",
                label: t("lowest_to_highest")
            }
        ], [
        t
    ]);
    const filterOptions = [
        {
            label: t("drafted"),
            value: "DRAFT"
        },
        {
            label: t("published"),
            value: "PUBLISHED"
        },
        {
            label: t("hidden"),
            value: "HIDDEN"
        },
        {
            label: t("reported"),
            value: "REPORTED"
        }
    ];
    const sortData = (dataToSort, sortKey)=>{
        return [
            ...dataToSort
        ].sort((a, b)=>{
            if (sortKey === "HL") {
                return b.count - a.count;
            } else {
                return a.count - b.count;
            }
        });
    };
    (0,react.useEffect)(()=>{
        const sortedData = sortData(data, sortOption.key);
        setData(sortedData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sortOption
    ]);
    (0,react.useEffect)(()=>{
        getIdeaTopics({
            variables: {
                statuses: filter
            }
        });
    }, [
        filter,
        getIdeaTopics
    ]);
    const config = {
        data: data,
        xField: "count",
        yField: "name",
        color: "#3BA1FF",
        appendPadding: [
            0,
            20,
            0,
            0
        ],
        yAxis: {
            label: {
                style: {
                    fontFamily: "Lufga",
                    fill: "rgba(0, 0, 0, 0.65)",
                    textAlign: "right"
                },
                labelFormatter: (value)=>{
                    const str = value.toString();
                    if (str.length > 20) {
                        return str.slice(0, 20) + "...";
                    }
                    return str;
                }
            }
        },
        label: {
            text: "count",
            position: "right",
            textAlign: "start",
            dx: 8,
            style: {
                fill: "rgba(0, 0, 0, 0.65)",
                fontFamily: "Lufga"
            }
        },
        interaction: {
            tooltip: {
                name: "name",
                render: (event, param)=>{
                    let { title , items  } = param;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    t("count"),
                                    ": ",
                                    items[0].value
                                ]
                            })
                        ]
                    });
                }
            }
        }
    };
    const handleFilterChange = (value)=>{
        setFilter(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        className: "".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center space-x-3 space-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-sm text-gray-900 font-medium text-nowrap",
                            children: t("ideas_by_topics")
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* default */.Z, {
                                menu: {
                                    items: sortOptions.map((item)=>({
                                            ...item,
                                            onClick: ()=>setSortOption(item)
                                        }))
                                },
                                placement: "bottomRight",
                                trigger: [
                                    "click"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_button/* default */.ZP, {
                                    shape: "round",
                                    children: [
                                        sortOption.label,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined/* default */.Z, {})
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex space-x-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                            onChange: handleFilterChange,
                            options: filterOptions,
                            value: filter,
                            placeholder: "",
                            allowClear: true,
                            mode: "multiple",
                            style: {
                                width: "100%"
                            },
                            maxTagCount: "responsive",
                            optionFilterProp: "label"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                            onChange: (value)=>setTopicFilter(value),
                            options: data === null || data === void 0 ? void 0 : data.map((item)=>({
                                    label: item.name,
                                    value: item.name
                                })),
                            value: topicFilter,
                            placeholder: t("filter_by_topic"),
                            allowClear: true,
                            mode: "multiple",
                            style: {
                                width: "100%"
                            },
                            maxTagCount: "responsive",
                            optionFilterProp: "label"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bar/* default */.Z, {
                    loading: loading,
                    ...config,
                    data: data === null || data === void 0 ? void 0 : data.filter((item)=>{
                        return topicFilter.length === 0 || topicFilter.includes(item === null || item === void 0 ? void 0 : item.name);
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var IdeasGraphs_PopularTopicsStats = (PopularTopicsStats_PopularTopicsStats);

// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/QuestionCircleOutlined.js + 1 modules
var QuestionCircleOutlined = __webpack_require__(77138);
// EXTERNAL MODULE: ../../node_modules/antd/es/typography/index.js + 20 modules
var typography = __webpack_require__(19428);
// EXTERNAL MODULE: ../../node_modules/antd/es/avatar/index.js + 4 modules
var avatar = __webpack_require__(3409);
// EXTERNAL MODULE: ../../node_modules/antd/es/tooltip/index.js + 3 modules
var tooltip = __webpack_require__(70020);
// EXTERNAL MODULE: ../../node_modules/rc-util/es/omit.js
var omit = __webpack_require__(94899);
// EXTERNAL MODULE: ../../node_modules/antd/es/_util/PurePanel.js
var PurePanel = __webpack_require__(43354);
// EXTERNAL MODULE: ../../node_modules/antd/node_modules/classnames/index.js
var classnames = __webpack_require__(25743);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/rc-util/es/Children/toArray.js
var toArray = __webpack_require__(33514);
// EXTERNAL MODULE: ../../node_modules/antd/es/_util/hooks/useZIndex.js
var useZIndex = __webpack_require__(39212);
// EXTERNAL MODULE: ../../node_modules/antd/es/config-provider/context.js
var context = __webpack_require__(35298);
;// CONCATENATED MODULE: ../../node_modules/antd/es/auto-complete/AutoComplete.js
"use client";









const {
  Option: AutoComplete_Option
} = es_select/* default */.Z;
function isSelectOptionOrSelectOptGroup(child) {
  return (child === null || child === void 0 ? void 0 : child.type) && (child.type.isSelectOption || child.type.isSelectOptGroup);
}
const AutoComplete = (props, ref) => {
  var _a;
  const {
    prefixCls: customizePrefixCls,
    className,
    popupClassName,
    dropdownClassName,
    children,
    dataSource
  } = props;
  const childNodes = (0,toArray/* default */.Z)(children);
  // ============================= Input =============================
  let customizeInput;
  if (childNodes.length === 1 && /*#__PURE__*/react.isValidElement(childNodes[0]) && !isSelectOptionOrSelectOptGroup(childNodes[0])) {
    [customizeInput] = childNodes;
  }
  const getInputElement = customizeInput ? () => customizeInput : undefined;
  // ============================ Options ============================
  let optionChildren;
  // [Legacy] convert `children` or `dataSource` into option children
  if (childNodes.length && isSelectOptionOrSelectOptGroup(childNodes[0])) {
    optionChildren = children;
  } else {
    optionChildren = dataSource ? dataSource.map(item => {
      if (/*#__PURE__*/react.isValidElement(item)) {
        return item;
      }
      switch (typeof item) {
        case 'string':
          return /*#__PURE__*/react.createElement(AutoComplete_Option, {
            key: item,
            value: item
          }, item);
        case 'object':
          {
            const {
              value: optionValue
            } = item;
            return /*#__PURE__*/react.createElement(AutoComplete_Option, {
              key: optionValue,
              value: optionValue
            }, item.text);
          }
        default:
          return undefined;
      }
    }) : [];
  }
  if (false) {}
  const {
    getPrefixCls
  } = react.useContext(context/* ConfigContext */.E_);
  const prefixCls = getPrefixCls('select', customizePrefixCls);
  // ============================ zIndex ============================
  const [zIndex] = (0,useZIndex/* useZIndex */.Cn)('SelectLike', (_a = props.dropdownStyle) === null || _a === void 0 ? void 0 : _a.zIndex);
  return /*#__PURE__*/react.createElement(es_select/* default */.Z, Object.assign({
    ref: ref,
    suffixIcon: null
  }, (0,omit/* default */.Z)(props, ['dataSource', 'dropdownClassName']), {
    prefixCls: prefixCls,
    popupClassName: popupClassName || dropdownClassName,
    dropdownStyle: Object.assign(Object.assign({}, props.dropdownStyle), {
      zIndex
    }),
    className: classnames_default()(`${prefixCls}-auto-complete`, className),
    mode: es_select/* default.SECRET_COMBOBOX_MODE_DO_NOT_USE */.Z.SECRET_COMBOBOX_MODE_DO_NOT_USE,
    // Internal api
    getInputElement
  }), optionChildren);
};
const RefAutoComplete = /*#__PURE__*/react.forwardRef(AutoComplete);
if (false) {}
/* harmony default export */ var auto_complete_AutoComplete = (RefAutoComplete);
;// CONCATENATED MODULE: ../../node_modules/antd/es/auto-complete/index.js
"use client";





const {
  Option: auto_complete_Option
} = es_select/* default */.Z;
// We don't care debug panel
/* istanbul ignore next */
const auto_complete_PurePanel = (0,PurePanel/* default */.Z)(auto_complete_AutoComplete, 'dropdownAlign', props => (0,omit/* default */.Z)(props, ['visible']));
const es_auto_complete_AutoComplete = auto_complete_AutoComplete;
es_auto_complete_AutoComplete.Option = auto_complete_Option;
es_auto_complete_AutoComplete._InternalPanelDoNotUseOrYouWillBeFired = auto_complete_PurePanel;
/* harmony default export */ var auto_complete = (es_auto_complete_AutoComplete);
;// CONCATENATED MODULE: ./src/features/dashboard/components/IdeasGraphs/TopIdeasByExpertStats.tsx










const DEFAULT_LIMIT = 9;
const { Text  } = typography/* default */.Z;
function TopIdeasByExpertStats(param) {
    let { className  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { t: tcommon  } = (0,useTranslation/* default */.Z)("common");
    const [challengeId, setChallengeId] = (0,react.useState)(null);
    const [options, setOptions] = (0,react.useState)([]);
    const [businessAreas, setBusinessAreas] = (0,react.useState)([]);
    const [selectedChallengeName, setSelectedChallengeName] = (0,react.useState)("");
    const [getChallenge] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_INTRAPRENEUR_CHALLENGES_BASIC */.DbK, {
        fetchPolicy: "no-cache",
        onCompleted: (data)=>{
            setOptions(data.internalChallenges.map((challenge)=>({
                    value: challenge.id,
                    label: challenge.title
                })));
        }
    });
    const [getTopIdeas, { data , loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_TOP_IDEAS_BY_HIGHEST_SCORE */.IAv, {
        fetchPolicy: "no-cache"
    });
    const { data: businessArea  } = (0,useQuery/* useQuery */.a)(src/* GET_BUSINESS_AREA_TAGS */.EyM);
    const businessAreaOptions = (0,react.useMemo)(()=>{
        return businessArea === null || businessArea === void 0 ? void 0 : businessArea.pocBusinessAreaTags.map((b)=>({
                label: b.parentName ? "".concat(b.parentName, " - ").concat(b.name) : b.name,
                value: b.name
            }));
    }, [
        businessArea
    ]);
    (0,react.useEffect)(()=>{
        getTopIdeas({
            variables: {
                challengeId: challengeId,
                businessArea: businessAreas,
                limit: 10
            }
        });
    }, [
        businessAreas,
        challengeId,
        getTopIdeas
    ]);
    const filterCriteriaResult = (data)=>{
        return data.filter((r)=>{
            return (r === null || r === void 0 ? void 0 : r.status) === "DONE";
        });
    };
    const results = (0,react.useMemo)(()=>{
        return data === null || data === void 0 ? void 0 : data.dashboardIdeasByAverageScore.map((idea)=>{
            return filterCriteriaResult(idea.channelCriteriaResults);
        });
    }, [
        data
    ]);
    const criteria = (0,react.useMemo)(()=>{
        return (data === null || data === void 0 ? void 0 : data.dashboardIdeasByAverageScore.map((idea)=>{
            return idea.channelCriteria;
        })) || [];
    }, [
        data
    ]);
    const IdeaAvatar = (param)=>{
        let { data  } = param;
        var ref, ref1;
        const covertName = (name)=>{
            const splittedStr = name.split(/(\s+)/);
            let str = "";
            splittedStr.forEach((s)=>{
                if (s.trim() !== "") {
                    str = str.concat(s.trim().charAt(0).toUpperCase());
                }
            });
            return str;
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/idea-management/" + (data === null || data === void 0 ? void 0 : data.id),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-2 w-48",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.Z, {
                        shape: "square",
                        src: (data === null || data === void 0 ? void 0 : (ref = data.coverPhotoUrl) === null || ref === void 0 ? void 0 : ref.imageUrl) || (data === null || data === void 0 ? void 0 : (ref1 = data.coverPhoto) === null || ref1 === void 0 ? void 0 : ref1.url),
                        className: "cursor-pointer w-8 h-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: (data === null || data === void 0 ? void 0 : data.name) && covertName(data.name)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        className: "flex-1 line-clamp-2",
                        children: data === null || data === void 0 ? void 0 : data.name
                    })
                ]
            })
        });
    };
    const calculateAverageScoreIdeaChannel = (data)=>{
        const average = (data === null || data === void 0 ? void 0 : data.reduce((prev, curr)=>{
            return prev + (curr === null || curr === void 0 ? void 0 : curr.score);
        }, 0)) / (data === null || data === void 0 ? void 0 : data.length);
        return isNaN(average) ? undefined : average.toFixed(1);
    };
    const CriteriaProgress = (param)=>{
        let { data , result  } = param;
        const finalResult = result.filter((r)=>{
            var ref;
            return (r === null || r === void 0 ? void 0 : (ref = r.criteria) === null || ref === void 0 ? void 0 : ref.id) === (data === null || data === void 0 ? void 0 : data.id) && (r === null || r === void 0 ? void 0 : r.status) === "DONE";
        });
        const percent = finalResult.reduce((prev, result)=>{
            return prev + (result === null || result === void 0 ? void 0 : result.score);
        }, 0) * (data === null || data === void 0 ? void 0 : data.scale) / finalResult.length;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex justify-end text-center space-y-2 font-medium",
            children: percent ? (percent / 10).toFixed(1) : "-"
        });
    };
    const columns = [
        {
            dataIndex: "index",
            key: "index",
            title: t("no"),
            render: (_, __, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        index + 1,
                        "."
                    ]
                })
        },
        {
            dataIndex: "idea",
            key: "idea",
            title: t("idea_name"),
            render: (_, record)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(IdeaAvatar, {
                    data: record
                })
        },
        {
            dataIndex: "createdBy",
            key: "createdBy",
            title: t("created_by"),
            render: (_, record)=>{
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "flex space-x-2 items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* UserAvatar */.Yt, {
                            size: 40,
                            user: record.createdBy,
                            showBadge: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-32 truncate",
                            children: (ref = record.createdBy) === null || ref === void 0 ? void 0 : ref.fullName
                        })
                    ]
                });
            }
        },
        {
            dataIndex: "averageScore",
            key: "averageScore",
            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "align-middle",
                children: [
                    t("avg_score"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                        title: t("avg_score_tooltip"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionCircleOutlined/* default */.Z, {
                            className: "cursor-pointer"
                        })
                    })
                ]
            }),
            width: 150,
            sorter: (a, b)=>{
                return parseFloat(calculateAverageScoreIdeaChannel(filterCriteriaResult(a.channelCriteriaResults))) - parseFloat(calculateAverageScoreIdeaChannel(filterCriteriaResult(b.channelCriteriaResults)));
            },
            defaultSortOrder: "descend",
            sortDirections: [
                "descend",
                "ascend"
            ],
            render: (_, record, index)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: calculateAverageScoreIdeaChannel(filterCriteriaResult(record.channelCriteriaResults)) || "-"
                });
            }
        },
        {
            dataIndex: "desirability",
            key: "desirability",
            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "align-middle",
                children: [
                    "D",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                        title: t("desirability_tooltip"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionCircleOutlined/* default */.Z, {
                            className: "cursor-pointer"
                        })
                    })
                ]
            }),
            width: 70,
            render: (_, __, index)=>{
                const value = criteria[index].find((r)=>{
                    return (r === null || r === void 0 ? void 0 : r.name.trim().toLowerCase()) === "desirability";
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                    title: t("desirability"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CriteriaProgress, {
                        data: value,
                        result: results[index]
                    })
                });
            }
        },
        {
            dataIndex: "viability",
            key: "viability",
            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "align-middle",
                children: [
                    "V",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                        title: t("viability_tooltip"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionCircleOutlined/* default */.Z, {
                            className: "cursor-pointer"
                        })
                    })
                ]
            }),
            width: 70,
            render: (_, __, index)=>{
                const value = criteria[index].find((r)=>{
                    return (r === null || r === void 0 ? void 0 : r.name.trim().toLowerCase()) === "viability";
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                    title: t("viability"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CriteriaProgress, {
                        data: value,
                        result: results[index]
                    })
                });
            }
        },
        {
            dataIndex: "feasibility",
            key: "feasibility",
            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "align-middle",
                children: [
                    "F",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                        title: t("feasibility_tooltip"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionCircleOutlined/* default */.Z, {
                            className: "cursor-pointer"
                        })
                    })
                ]
            }),
            width: 70,
            render: (_, __, index)=>{
                const value = criteria[index].find((r)=>{
                    return (r === null || r === void 0 ? void 0 : r.name.trim().toLowerCase()) === "feasibility";
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                    title: t("feasibility"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CriteriaProgress, {
                        data: value,
                        result: results[index]
                    })
                });
            }
        },
        {
            dataIndex: "likes",
            key: "likes",
            title: t("upvotes"),
            sorter: (a, b)=>a.likes - b.likes,
            render: (value)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        value,
                        " ",
                        t("upvotes")
                    ]
                })
        },
        {
            dataIndex: "contributeCount",
            key: "contributeCount",
            title: t("contributions"),
            sorter: (a, b)=>a.contributeCount - b.contributeCount,
            render: (value)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("count_contributions", {
                        count: value
                    })
                })
        },
        {
            dataIndex: "createdAt",
            key: "createdAt",
            title: t("submitted_date"),
            render: (value)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: dayjs_min_default()(value).format("DD MMM YYYY, HH:mm")
                })
        },
        {
            dataIndex: [
                "innovationSpaceTag",
                "name"
            ],
            key: "innovationSpaceTag",
            title: t("innovation_space"),
            width: 200,
            render: (value)=>value && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "rounded-md py-1 px-3 bg-gray-200 text-gray-900 w-fit line-clamp-2 max-w-32 text-wrap",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-normal text-xs",
                        children: value
                    })
                })
        }
    ];
    const handleBusinessAreaChange = (value)=>{
        setBusinessAreas(value);
    };
    const onSearch = (query)=>{
        getChallenge({
            variables: {
                page: 0,
                limit: DEFAULT_LIMIT,
                filterBy: {
                    states: [
                        "ACTIVE",
                        "DRAFT",
                        "ENDED",
                        "UPCOMING",
                        "ARCHIVED"
                    ],
                    challengeName: query
                },
                sort: "CREATION_DATE"
            }
        });
    };
    const onChange = (value)=>{
        if (!value) {
            setChallengeId(null);
            setSelectedChallengeName("");
        } else {
            setSelectedChallengeName(value);
            // Only clear the challenge ID if we're typing something new (not matching a selection)
            const matchingChallenge = options.find((option)=>option.label === value);
            if (!matchingChallenge) {
                setChallengeId(null);
            }
        }
    };
    const onSelect = (challengeId)=>{
        setChallengeId(challengeId || null);
        // Find the challenge name from options based on the selected ID
        const selectedOption = options.find((option)=>option.value === challengeId);
        if (selectedOption) {
            setSelectedChallengeName(selectedOption.label);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between font-medium mb-6 space-x-4 items-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("top_10_ideas")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex gap-2 items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: t("business_area")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                                        onChange: handleBusinessAreaChange,
                                        options: businessAreaOptions,
                                        value: businessAreas,
                                        maxTagCount: "responsive",
                                        placeholder: t("search_idea_by_business_area"),
                                        allowClear: true,
                                        mode: "multiple",
                                        className: "!w-[250px]",
                                        optionFilterProp: "label"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex gap-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: tcommon("select_challenge")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                                title: t("search_idea_by_challenge_tooltip"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionCircleOutlined/* default */.Z, {
                                                    className: "cursor-pointer"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(auto_complete, {
                                        className: "!w-[250px]",
                                        popupClassName: "certain-category-search-dropdown",
                                        style: {
                                            width: "100%"
                                        },
                                        options: options,
                                        onChange: onChange,
                                        onSelect: onSelect,
                                        onSearch: onSearch,
                                        value: selectedChallengeName,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default.Search */.Z.Search, {
                                            placeholder: t("search_by_challenge_name"),
                                            allowClear: true
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default */.Z, {
                className: "overflow-auto",
                columns: columns,
                dataSource: (data === null || data === void 0 ? void 0 : data.dashboardIdeasByAverageScore) || [],
                pagination: false,
                bordered: true,
                loading: loading,
                rowKey: "id"
            })
        ]
    });
}
/* harmony default export */ var IdeasGraphs_TopIdeasByExpertStats = (TopIdeasByExpertStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/IdeasGraphs/TotalIdeaStats.tsx








const { RangePicker: TotalIdeaStats_RangePicker  } = date_picker/* default */.Z;
const TotalIdeaStats_filterOptions = [
    {
        label: "Drafted",
        value: "DRAFT"
    },
    {
        label: "Published",
        value: "PUBLISHED"
    },
    {
        label: "Hidden",
        value: "HIDDEN"
    },
    {
        label: "Reported",
        value: "REPORTED"
    }
];
const TotalIdeaStats_COLOR_PLATE_10 = [
    "#2FC25B",
    "#2888ED",
    "#62BAFC",
    "#36CBCB",
    "#525355"
];
function TotalIdeaStats() {
    var ref, ref1;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { t: tcommon  } = (0,useTranslation/* default */.Z)("common");
    const endDate = dayjs_min_default()();
    const startDate = dayjs_min_default()().subtract(3, "month");
    const [data, setData] = (0,react.useState)([]);
    const [date, setDate] = (0,react.useState)([
        startDate.format("YYYY-MM-DD"),
        endDate.format("YYYY-MM-DD")
    ]);
    const monthNames = (0,react.useMemo)(()=>[
            tcommon("Jan"),
            tcommon("Feb"),
            tcommon("Mar"),
            tcommon("Apr"),
            tcommon("May"),
            tcommon("Jun"),
            tcommon("Jul"),
            tcommon("Aug"),
            tcommon("Sep"),
            tcommon("Oct"),
            tcommon("Nov"),
            tcommon("Dec")
        ], [
        tcommon
    ]);
    const [filter, setFilter] = (0,react.useState)([
        "DRAFT",
        "PUBLISHED",
        "HIDDEN",
        "REPORTED"
    ]);
    const [getData, { data: rawData , loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_TOTAL_IDEAS_BY_RANGE */.LvA, {
        fetchPolicy: "no-cache",
        onCompleted: (rawData)=>{
            var ref;
            const sortedData = rawData === null || rawData === void 0 ? void 0 : (ref = rawData.dashboardTotalIdeas) === null || ref === void 0 ? void 0 : ref.list.sort((a, b)=>new Date(a.date).getTime() - new Date(b.date).getTime());
            const result = sortedData.map((state)=>({
                    name: state.name,
                    date: state.date,
                    count: state.count
                }));
            const aggregatedData = Object.values(sortedData.reduce((acc, current)=>{
                if (!acc[current.date]) {
                    acc[current.date] = {
                        name: "All",
                        date: current.date,
                        count: 0
                    };
                }
                acc[current.date].count += current.count;
                return acc;
            }, {}));
            const finalResult = [
                ...aggregatedData,
                ...result
            ];
            setData(finalResult);
        }
    });
    (0,react.useEffect)(()=>{
        if (date.length) {
            getData({
                variables: {
                    startDate: date[0],
                    endDate: date[1],
                    statuses: filter
                }
            });
        }
    }, [
        date,
        filter,
        getData
    ]);
    const [selectedItems, setSelectedItems] = (0,react.useState)([]);
    const defaultSelectedItems = (0,react.useMemo)(()=>{
        if (data.length > 0) {
            return data.map((item)=>item.name);
        }
        return [];
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        setSelectedItems(defaultSelectedItems);
    }, [
        defaultSelectedItems
    ]);
    const config = (0,react.useMemo)(()=>{
        return {
            data: data,
            loading: loading,
            xField: "date",
            yField: "count",
            seriesField: "name",
            colorField: "name",
            animate: {
                enter: {
                    type: "pathIn"
                }
            },
            style: {
                lineWidth: 2
            },
            scale: {
                color: {
                    range: TotalIdeaStats_COLOR_PLATE_10
                }
            },
            axis: {
                x: {
                    labelFormatter: (v)=>{
                        const monthIndex = parseInt(v.split("-")[1], 10) - 1;
                        return monthNames[monthIndex];
                    }
                }
            },
            legend: {
                color: {
                    position: "bottom",
                    autoWrap: true,
                    itemMarker: "square",
                    style: {
                        fontSize: 14,
                        fontFamily: "Lufga"
                    },
                    layout: {
                        justifyContent: "center",
                        alignItems: "center"
                    }
                }
            },
            onReady: (param)=>{
                let { chart  } = param;
                chart.on("legend:filter", (e)=>{
                    var ref;
                    if (e === null || e === void 0 ? void 0 : (ref = e.data) === null || ref === void 0 ? void 0 : ref.values) {
                        var ref1;
                        const values = e === null || e === void 0 ? void 0 : (ref1 = e.data) === null || ref1 === void 0 ? void 0 : ref1.values;
                        setSelectedItems([
                            ...values
                        ]);
                    }
                });
            },
            interactions: [
                {
                    type: "legend-filter"
                }
            ],
            animation: {
                appear: {
                    animation: "path-in",
                    duration: 5000
                }
            },
            label: {
                text: "count",
                position: "top",
                textAlign: "center",
                dy: -10,
                style: {
                    fontFamily: "Lufga"
                }
            }
        };
    }, [
        data,
        loading,
        monthNames
    ]);
    const visibleTotal = (0,react.useMemo)(()=>{
        if (selectedItems.includes("All")) {
            return data.filter((item)=>item.name === "All").reduce((acc, curr)=>acc + curr.count, 0);
        } else {
            return data.filter((item)=>item.name !== "All" && selectedItems.includes(item.name)).reduce((acc, curr)=>acc + curr.count, 0);
        }
    }, [
        data,
        selectedItems
    ]);
    const handleChange = (dates, dateStrings)=>{
        if (dates) {
            setDate([
                dateStrings[0],
                dateStrings[1]
            ]);
        }
    };
    const handleFilterChange = (value)=>{
        setFilter(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            className: "flex items-center flex-wrap gap-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("total_during_period")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text-gray-700 font-medium",
                                    children: [
                                        "/ ",
                                        t("total_all_time")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalIdeaStats_RangePicker, {
                                onChange: handleChange,
                                defaultValue: [
                                    dayjs_min_default()(date[0]),
                                    dayjs_min_default()(date[1])
                                ],
                                style: {
                                    borderRadius: 20
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                    mode: "tags",
                    style: {
                        width: "100%"
                    },
                    onChange: handleFilterChange,
                    tokenSeparators: [
                        ","
                    ],
                    options: TotalIdeaStats_filterOptions,
                    value: filter
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center flex-wrap gap-1 my-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-gray-900 text-3xl",
                            children: visibleTotal
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-gray-700 text-2xl",
                            children: [
                                "/ ",
                                rawData === null || rawData === void 0 ? void 0 : (ref = rawData.dashboardTotalIdeas) === null || ref === void 0 ? void 0 : (ref1 = ref.total) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString()
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(line/* default */.Z, {
                    ...config
                })
            ]
        })
    });
}
/* harmony default export */ var IdeasGraphs_TotalIdeaStats = (TotalIdeaStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/IdeasGraphs/index.tsx





// import TopIdeasByLikesStats from './TopIdeasByLikesStats';

function IdeasGraphs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid md:grid-cols-2 gap-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeasGraphs_TotalIdeaStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeasGraphs_IdeaAreaStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeasGraphs_PopularRegionStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeasGraphs_PopularTopicsStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeasGraphs_TopIdeasByExpertStats, {
                className: "col-span-2"
            })
        ]
    });
}
/* harmony default export */ var components_IdeasGraphs = (IdeasGraphs);

;// CONCATENATED MODULE: ./src/features/dashboard/components/InnovationSpaceGraphs/InnovationContentStats.tsx








const calculateDateRange = (period)=>{
    const endDate = dayjs_min_default()().format("YYYY-MM-DD");
    let startDate;
    switch(period){
        case "week":
            startDate = dayjs_min_default()().subtract(7, "day").format("YYYY-MM-DD");
            break;
        case "month":
            startDate = dayjs_min_default()().subtract(30, "day").format("YYYY-MM-DD");
            break;
        case "quarter":
            startDate = dayjs_min_default()().subtract(3, "month").format("YYYY-MM-DD");
            break;
        case "year":
            startDate = dayjs_min_default()().subtract(1, "year").format("YYYY-MM-DD");
            break;
        default:
            throw new Error("Invalid period");
    }
    return {
        startDate,
        endDate
    };
};
const InnovationContentStats = ()=>{
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const [filterPeriod, setFilterPeriod] = (0,react.useState)("week");
    const [searchTerm, setSearchTerm] = (0,react.useState)(""); // New state for search term
    // Calculate default date range for last week
    const { startDate: defaultStartDate , endDate: defaultEndDate  } = (0,react.useMemo)(()=>calculateDateRange("week"), []);
    const filterSelections = (0,react.useMemo)(()=>[
            {
                label: t("last_week"),
                value: "week"
            },
            {
                label: t("last_30_days"),
                value: "month"
            },
            {
                label: t("last_3_months"),
                value: "quarter"
            },
            {
                label: t("last_year"),
                value: "year"
            }
        ], [
        t
    ]);
    const [getData, { data , loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_INNOVATION_CONTENT_STATISTICS */.FxH);
    // Fetch data on component mount with default date range
    (0,react.useEffect)(()=>{
        getData({
            variables: {
                startDate: defaultStartDate,
                endDate: defaultEndDate
            }
        });
    }, [
        getData,
        defaultStartDate,
        defaultEndDate
    ]);
    // Handle data fetching when filter selection changes
    const handleFilterChange = (0,react.useCallback)((value)=>{
        setFilterPeriod(value);
        const { startDate , endDate  } = calculateDateRange(value);
        getData({
            variables: {
                startDate,
                endDate
            }
        });
    }, [
        getData
    ]);
    const columns = (0,react.useMemo)(()=>[
            {
                title: t("innovation_spaces"),
                dataIndex: "name",
                key: "name",
                width: 330
            },
            {
                title: t("type"),
                dataIndex: "type",
                key: "type",
                render: (type)=>(0,util_src/* getLinkLabel */.en)(type.toLowerCase())
            },
            {
                title: t("no_of_users"),
                dataIndex: "users",
                key: "users"
            },
            {
                title: t("no_of_ideas"),
                dataIndex: "ideas",
                key: "ideas",
                render: (ideas)=>ideas.filter((item)=>item.status === "APPROVED" || item.status === "PUBLISHED").reduce((acc, curr)=>acc + curr.count, 0)
            },
            {
                title: t("no_of_challenges"),
                dataIndex: "challenges",
                key: "challenges"
            },
            {
                title: t("no_of_posts_events"),
                dataIndex: "posts",
                key: "posts",
                render: (posts)=>posts.filter((item)=>item.status === "APPROVED" || item.status === "PUBLISHED").reduce((acc, curr)=>acc + curr.count, 0)
            }
        ], [
        t
    ]);
    // Filter data based on search term
    const filteredData = (0,react.useMemo)(()=>{
        if (!(data === null || data === void 0 ? void 0 : data.innovationSpaceContentStatistics) || !searchTerm) {
            return (data === null || data === void 0 ? void 0 : data.innovationSpaceContentStatistics) || [];
        }
        return data.innovationSpaceContentStatistics.filter((item)=>item.name.toLowerCase().includes(searchTerm.toLowerCase()));
    }, [
        data,
        searchTerm
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-end gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                        placeholder: t("search_by_name"),
                        className: "!w-64",
                        value: searchTerm,
                        onChange: (e)=>setSearchTerm(e.target.value)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                        defaultValue: filterPeriod,
                        onChange: (value)=>handleFilterChange(value),
                        options: filterSelections
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default */.Z, {
                columns: columns,
                loading: loading,
                dataSource: filteredData,
                rowKey: "name"
            })
        ]
    });
};
/* harmony default export */ var InnovationSpaceGraphs_InnovationContentStats = (InnovationContentStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/InnovationSpaceGraphs/index.tsx


function InnovationSpaceGraphs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-1 gap-6",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnovationSpaceGraphs_InnovationContentStats, {})
    });
}
/* harmony default export */ var components_InnovationSpaceGraphs = (InnovationSpaceGraphs);

// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(66380);
;// CONCATENATED MODULE: ../../node_modules/@ant-design/icons-svg/es/asn/RiseOutlined.js
// This icon file is generated automatically.
var RiseOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M917 211.1l-199.2 24c-6.6.8-9.4 8.9-4.7 13.6l59.3 59.3-226 226-101.8-101.7c-6.3-6.3-16.4-6.2-22.6 0L100.3 754.1a8.03 8.03 0 000 11.3l45 45.2c3.1 3.1 8.2 3.1 11.3 0L433.3 534 535 635.7c6.3 6.2 16.4 6.2 22.6 0L829 364.5l59.3 59.3a8.01 8.01 0 0013.6-4.7l24-199.2c.7-5.1-3.7-9.5-8.9-8.8z" } }] }, "name": "rise", "theme": "outlined" };
/* harmony default export */ var asn_RiseOutlined = (RiseOutlined);

// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/components/AntdIcon.js + 8 modules
var AntdIcon = __webpack_require__(32038);
;// CONCATENATED MODULE: ../../node_modules/@ant-design/icons/es/icons/RiseOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var RiseOutlined_RiseOutlined = function RiseOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_RiseOutlined
  }));
};

/**![rise](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxNyAyMTEuMWwtMTk5LjIgMjRjLTYuNi44LTkuNCA4LjktNC43IDEzLjZsNTkuMyA1OS4zLTIyNiAyMjYtMTAxLjgtMTAxLjdjLTYuMy02LjMtMTYuNC02LjItMjIuNiAwTDEwMC4zIDc1NC4xYTguMDMgOC4wMyAwIDAwMCAxMS4zbDQ1IDQ1LjJjMy4xIDMuMSA4LjIgMy4xIDExLjMgMEw0MzMuMyA1MzQgNTM1IDYzNS43YzYuMyA2LjIgMTYuNCA2LjIgMjIuNiAwTDgyOSAzNjQuNWw1OS4zIDU5LjNhOC4wMSA4LjAxIDAgMDAxMy42LTQuN2wyNC0xOTkuMmMuNy01LjEtMy43LTkuNS04LjktOC44eiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/react.forwardRef(RiseOutlined_RiseOutlined);
if (false) {}
/* harmony default export */ var icons_RiseOutlined = (RefIcon);
;// CONCATENATED MODULE: ./src/features/dashboard/components/InsightsGraphs/CompaniesEngagementStats.tsx







function CompaniesEngagementStats(param) {
    let { className  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        className: "".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap items-start gap-x-6 gap-y-4 mb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grow",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-medium text-base",
                            children: t("companies_engagement")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/?graph=companies",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-3 cursor-pointer rounded-lg px-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "rounded-full h-10 w-10 bg-primary-600 text-white text-center flex items-center justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_RiseOutlined, {
                                        size: 30
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-primary-600",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("view_more_details")
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid md:grid-cols-2 gap-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesGraphs_TotalCompaniesStats, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesGraphs_PitchUploadedStats, {})
                ]
            })
        ]
    });
}
/* harmony default export */ var InsightsGraphs_CompaniesEngagementStats = (CompaniesEngagementStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/InsightsGraphs/IdeaEngagementStats.tsx







function IdeaEngagementStats(param) {
    let { className  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        className: "".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap items-start gap-x-6 gap-y-4 mb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grow",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "font-medium text-base",
                                children: t("idea_engagement")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-normal text-gray-900",
                                children: t("numbers_of_ideas")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/?graph=ideas",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-3 cursor-pointer rounded-lg px-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "rounded-full h-10 w-10 bg-primary-600 text-white text-center flex items-center justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_RiseOutlined, {
                                        size: 30
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-primary-600",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("view_more_details")
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid md:grid-cols-2 gap-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeasGraphs_TotalIdeaStats, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeasGraphs_IdeaAreaStats, {})
                ]
            })
        ]
    });
}
/* harmony default export */ var InsightsGraphs_IdeaEngagementStats = (IdeaEngagementStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/PostsGraphs/TopEventsStats.tsx





function TopEventsStats() {
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { data , loading  } = (0,useQuery/* useQuery */.a)(src/* GET_TOP_EVENTS */.nh8);
    const columns = [
        {
            title: t("no"),
            dataIndex: "index",
            key: "index",
            render: (_, __, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "text-center",
                    children: [
                        index + 1,
                        "."
                    ]
                })
        },
        {
            title: t("event_name"),
            dataIndex: "name",
            key: "name",
            render: (text, record)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: text
                })
        },
        {
            title: t("no_of_rsvps"),
            dataIndex: "total",
            key: "total",
            align: "center"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default */.Z, {
        rowKey: "name",
        columns: columns,
        dataSource: data === null || data === void 0 ? void 0 : data.dashboardTopEvents,
        pagination: false,
        loading: loading
    });
}
/* harmony default export */ var PostsGraphs_TopEventsStats = (TopEventsStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/PostsGraphs/TotalPosts.tsx








const { RangePicker: TotalPosts_RangePicker  } = date_picker/* default */.Z;
const TotalPosts = (param)=>{
    let { event =false  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { t: tcommon  } = (0,useTranslation/* default */.Z)("common");
    const endDate = dayjs_min_default()();
    const startDate = endDate.subtract(3, "month");
    const [date, setDate] = (0,react.useState)([
        startDate.format("YYYY-MM-DD"),
        endDate.format("YYYY-MM-DD")
    ]);
    const [getTotalPostsCount, { data: totalPosts , loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_TOTAL_POSTS_COUNT */.wSL);
    const monthNames = (0,react.useMemo)(()=>[
            tcommon("Jan"),
            tcommon("Feb"),
            tcommon("Mar"),
            tcommon("Apr"),
            tcommon("May"),
            tcommon("Jun"),
            tcommon("Jul"),
            tcommon("Aug"),
            tcommon("Sep"),
            tcommon("Oct"),
            tcommon("Nov"),
            tcommon("Dec")
        ], [
        tcommon
    ]);
    (0,react.useEffect)(()=>{
        if (date.length) {
            getTotalPostsCount({
                variables: {
                    startDate: date[0],
                    endDate: date[1],
                    event: event
                }
            });
        }
    }, [
        date,
        event,
        getTotalPostsCount
    ]);
    var ref;
    const config = {
        data: (ref = totalPosts === null || totalPosts === void 0 ? void 0 : totalPosts.dashboardPostCount) !== null && ref !== void 0 ? ref : [],
        height: 180,
        loading,
        xField: "name",
        yField: "total",
        color: "#1890FF",
        appendPadding: [
            20,
            0,
            0,
            0
        ],
        label: {
            style: {
                fill: "rgba(0, 0, 0, 0.65)",
                fontFamily: "Lufga"
            },
            textBaseline: "bottom"
        },
        xAxis: {
            label: {
                style: {
                    fontFamily: "Lufga"
                },
                autoHide: true,
                autoRotate: false,
                labelFormatter: (v)=>{
                    const monthIndex = parseInt(v.split("-")[1], 10) - 1;
                    return monthNames[monthIndex];
                }
            }
        },
        yAxis: {
            label: {
                style: {
                    fontFamily: "Lufga"
                }
            }
        }
    };
    const handleChange = (dates, dateStrings)=>{
        if (dates) {
            setDate([
                dateStrings[0],
                dateStrings[1]
            ]);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "flex items-center flex-wrap gap-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: event ? t("total_events_over_time") : t("total_posts_over_time")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalPosts_RangePicker, {
                                onChange: handleChange,
                                defaultValue: [
                                    dayjs_min_default()(date[0]),
                                    dayjs_min_default()(date[1])
                                ],
                                style: {
                                    borderRadius: 20
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(column/* default */.Z, {
                    ...config
                })
            ]
        })
    });
};
/* harmony default export */ var PostsGraphs_TotalPosts = (TotalPosts);

;// CONCATENATED MODULE: ./src/features/dashboard/components/InsightsGraphs/PostsEngagementStats.tsx





function PostsEngagementStats(param) {
    let { className  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
            style: {
                borderRadius: 20
            },
            className: "".concat(className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-wrap items-start gap-x-6 gap-y-4 mb-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grow",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-medium text-base",
                            children: t("posts_events_engagement")
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostsGraphs_TotalPosts, {
                                    event: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostsGraphs_TotalPosts, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostsGraphs_TopEventsStats, {})
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var InsightsGraphs_PostsEngagementStats = (PostsEngagementStats);

// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/DoubleRightOutlined.js + 1 modules
var DoubleRightOutlined = __webpack_require__(20304);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/LinkOutlined.js + 1 modules
var LinkOutlined = __webpack_require__(98436);
// EXTERNAL MODULE: ../../node_modules/antd/es/grid/index.js
var grid = __webpack_require__(68358);
// EXTERNAL MODULE: ../../node_modules/antd/es/empty/index.js + 3 modules
var empty = __webpack_require__(77813);
// EXTERNAL MODULE: ../../node_modules/antd/es/pagination/index.js + 11 modules
var pagination = __webpack_require__(27345);
// EXTERNAL MODULE: ../../node_modules/antd/es/drawer/index.js + 23 modules
var es_drawer = __webpack_require__(43449);
// EXTERNAL MODULE: ../../node_modules/next/config.js
var config = __webpack_require__(70314);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/features/dashboard/components/UsersGraphs/TopContributorsStats.tsx













const { RangePicker: TopContributorsStats_RangePicker  } = date_picker/* default */.Z;
const { useBreakpoint  } = grid/* default */.ZP;
var Tab;
(function(Tab) {
    Tab["POINT"] = "POINT";
    Tab["IDEA"] = "IDEA";
    Tab["POST"] = "POST";
    Tab["CHALLENGE"] = "CHALLENGE";
    Tab["UPVOTE"] = "UPVOTE";
    Tab["CONTRIBUTION"] = "CONTRIBUTION";
    Tab["APPLICATION"] = "APPLICATION";
})(Tab || (Tab = {}));
const TopContributorsStats = ()=>{
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { publicRuntimeConfig  } = config_default()();
    const [tab, setTab] = (0,react.useState)(Tab.POINT);
    const [current, setCurrent] = (0,react.useState)(1);
    const [drawer, setDrawer] = (0,react.useState)(false);
    const [selectedUser, setSelectedUser] = (0,react.useState)();
    const { t: tcommon  } = (0,useTranslation/* default */.Z)("common");
    const [option, setOption] = (0,react.useState)({
        key: "internal-users",
        label: t("internal_users")
    });
    const screens = useBreakpoint();
    const pageSize = 10;
    const endDate = dayjs_min_default()();
    const startDate = endDate.subtract(3, "month");
    const [date, setDate] = (0,react.useState)([
        startDate.format("YYYY-MM-DD"),
        endDate.format("YYYY-MM-DD")
    ]);
    const dropdownOptions = (0,react.useMemo)(()=>[
            {
                key: "internal-users",
                label: t("internal_users")
            },
            {
                key: "external-users",
                label: t("external_users")
            }
        ], [
        t
    ]);
    const internalSegmentOptions = (0,react.useMemo)(()=>[
            {
                value: "POINT",
                label: t("by_points")
            },
            {
                value: "IDEA",
                label: t("idea")
            },
            {
                value: "POST",
                label: t("post")
            },
            {
                value: "CHALLENGE",
                label: t("intra_challenge")
            },
            {
                value: "UPVOTE",
                label: t("upvote")
            },
            {
                value: "CONTRIBUTION",
                label: t("contribution")
            }
        ], [
        t
    ]);
    const externalSegmentOptions = [
        {
            value: "APPLICATION",
            label: t("open_challenge_application")
        },
        {
            value: "POST",
            label: t("post")
        }
    ];
    const [getTopUsers, { data , loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_TOP_CONTRIBUTORS */.Ajx, {
        fetchPolicy: "no-cache"
    });
    (0,react.useEffect)(()=>{
        if (option.key === "external-users") {
            setTab(Tab.APPLICATION);
        } else {
            setTab(Tab.POINT);
        }
    }, [
        option
    ]);
    (0,react.useEffect)(()=>{
        setCurrent(1);
        const variables = {
            input: {
                role: option.key === "internal-users" ? "INTRAPRENEUR" : "EXTERNAL_USER",
                content: tab,
                startDate: date[0],
                endDate: date[1]
            }
        };
        getTopUsers({
            variables
        });
    }, [
        date,
        getTopUsers,
        option.key,
        tab
    ]);
    const onChange = (page)=>{
        setCurrent(page);
    };
    const showDrawer = (user)=>{
        setSelectedUser(user);
        setDrawer(true);
    };
    const handleDrawer = ()=>{
        setDrawer(!drawer);
    };
    const renderCompany = (companies)=>{
        return companies.map((company, index)=>{
            const companyName = company.name.length > 20 ? company.name.slice(0, 20) + "..." : company.name;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: "hover:text-primary-700 cursor-pointer",
                href: "/company-management/".concat(company.id),
                target: "_blank",
                children: [
                    companyName,
                    index < companies.length - 1 && ", "
                ]
            }, company.id);
        });
    };
    const renderImage = (index)=>{
        if (index > 3) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "".concat(publicRuntimeConfig.staticFolder, "/svg/leaderboard/default.svg"),
                        height: "30",
                        width: "30",
                        alt: "badge",
                        className: "min-w-[30px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                        children: index
                    })
                ]
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "".concat(publicRuntimeConfig.staticFolder, "/svg/leaderboard/place-").concat(index, ".svg"),
                height: "30",
                width: "30",
                alt: "badge",
                className: "min-w-[30px]"
            });
        }
    };
    const List = ()=>{
        if (loading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-5 text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {})
            });
        }
        if (!(data === null || data === void 0 ? void 0 : data.getMostActiveUsers.length)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-5 text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(empty/* default */.Z, {
                    image: empty/* default.PRESENTED_IMAGE_SIMPLE */.Z.PRESENTED_IMAGE_SIMPLE
                })
            });
        }
        const startIndex = (current - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        const paginatedUsers = data.getMostActiveUsers.slice(startIndex, endIndex);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "flex flex-col gap-4 mt-5",
                    children: paginatedUsers.map((item, index)=>{
                        var ref, ref1, ref2, ref3;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                            className: "flex items-start gap-3 w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-none",
                                    children: renderImage(startIndex + index + 1)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-[40px] min-w-[40px] flex-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* UserAvatar */.Yt, {
                                        size: 40,
                                        user: item === null || item === void 0 ? void 0 : item.user,
                                        showBadge: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col flex-1 truncate",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "hover:text-primary-700 cursor-pointer line-clamp-1",
                                            onClick: ()=>{
                                                return showDrawer(item === null || item === void 0 ? void 0 : item.user);
                                            },
                                            children: [
                                                item === null || item === void 0 ? void 0 : (ref = item.user) === null || ref === void 0 ? void 0 : ref.fullName,
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-gray-700 text-xs text-wrap",
                                            children: option.key === "internal-users" ? "".concat((0,util_src/* formatNumber */.uf)(item === null || item === void 0 ? void 0 : (ref1 = item.user) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.rank) === null || ref2 === void 0 ? void 0 : ref2.rank), " ").concat(tcommon("points")) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    tcommon("from"),
                                                    " ",
                                                    renderCompany(item === null || item === void 0 ? void 0 : (ref3 = item.user) === null || ref3 === void 0 ? void 0 : ref3.companies)
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "flex-none py-1 px-4 text-xs bg-gray-400 rounded-full text-gray-900 font-normal whitespace-nowrap",
                                    children: getLabel(item)
                                })
                            ]
                        }, index);
                    })
                }),
                (data === null || data === void 0 ? void 0 : data.getMostActiveUsers.length) > pageSize && /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination/* default */.Z, {
                    total: data === null || data === void 0 ? void 0 : data.getMostActiveUsers.length,
                    pageSize: pageSize,
                    current: current,
                    onChange: onChange,
                    className: "!mt-5"
                })
            ]
        });
    };
    const handleChange = (dates, dateStrings)=>{
        if (dates) {
            setDate([
                dateStrings[0],
                dateStrings[1]
            ]);
        }
    };
    const disabledDate = (current)=>{
        return current && current > dayjs_min_default()().endOf("day");
    };
    const getLabel = (value)=>{
        switch(tab){
            case Tab.POINT:
                return t("number_points", {
                    number: (0,util_src/* formatNumber */.uf)(value === null || value === void 0 ? void 0 : value.points)
                });
            case Tab.IDEA:
                return t("number_ideas", {
                    number: (0,util_src/* formatNumber */.uf)(value === null || value === void 0 ? void 0 : value.ideas)
                });
            case Tab.POST:
                return t("number_posts", {
                    number: (0,util_src/* formatNumber */.uf)(value === null || value === void 0 ? void 0 : value.posts)
                });
            case Tab.CHALLENGE:
                return t("number_challenges", {
                    number: (0,util_src/* formatNumber */.uf)(value === null || value === void 0 ? void 0 : value.challenges)
                });
            case Tab.UPVOTE:
                return t("number_upvotes", {
                    number: (0,util_src/* formatNumber */.uf)(value === null || value === void 0 ? void 0 : value.upvotes)
                });
            case Tab.CONTRIBUTION:
                return t("number_contributions", {
                    number: (0,util_src/* formatNumber */.uf)(value === null || value === void 0 ? void 0 : value.contributions)
                });
            case Tab.APPLICATION:
                return t("number_submit", {
                    number: (0,util_src/* formatNumber */.uf)(value === null || value === void 0 ? void 0 : value.applications)
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
                style: {
                    borderRadius: 20
                },
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-sm text-gray-900 font-medium",
                        children: tcommon("top_contributors")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap justify-between items-center my-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* default */.Z, {
                                menu: {
                                    items: dropdownOptions.map((item)=>({
                                            ...item,
                                            onClick: ()=>setOption(item)
                                        }))
                                },
                                placement: "bottomRight",
                                trigger: [
                                    "click"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_button/* default */.ZP, {
                                    shape: "round",
                                    children: [
                                        option.label,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined/* default */.Z, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopContributorsStats_RangePicker, {
                                picker: "month",
                                onChange: handleChange,
                                defaultValue: [
                                    dayjs_min_default()(date[0]),
                                    dayjs_min_default()(date[1])
                                ],
                                disabledDate: disabledDate,
                                style: {
                                    borderRadius: 20,
                                    width: "250px"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(segmented/* default */.Z, {
                        value: tab,
                        options: option.key === "internal-users" ? internalSegmentOptions : externalSegmentOptions,
                        onChange: (value)=>setTab(value)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_drawer/* default */.Z, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                            ghost: true,
                            type: "text",
                            onClick: handleDrawer,
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoubleRightOutlined/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/user/".concat(selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.id),
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                                type: "primary",
                                shape: "round",
                                onClick: handleDrawer,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOutlined/* default */.Z, {}),
                                children: tcommon("user_profile_open_button")
                            })
                        })
                    ]
                }),
                placement: "right",
                closable: false,
                onClose: handleDrawer,
                open: drawer,
                width: screens.md ? "500" : null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* UserInfo */.ao, {
                    user: selectedUser
                })
            })
        ]
    });
};
/* harmony default export */ var UsersGraphs_TopContributorsStats = (TopContributorsStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/UsersGraphs/TotalUsers.tsx









const { RangePicker: TotalUsers_RangePicker  } = date_picker/* default */.Z;
const TotalUsers = ()=>{
    var ref;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { t: tcommon  } = (0,useTranslation/* default */.Z)("common");
    const { data: totalUsers  } = (0,useQuery/* useQuery */.a)(src/* GET_TOTAL_USERS_COUNT */.hBF);
    const endDate = dayjs_min_default()();
    const startDate = endDate.subtract(3, "month");
    const [date, setDate] = (0,react.useState)([
        startDate.format("YYYY-MM-DD"),
        endDate.format("YYYY-MM-DD")
    ]);
    const monthNames = (0,react.useMemo)(()=>[
            tcommon("Jan"),
            tcommon("Feb"),
            tcommon("Mar"),
            tcommon("Apr"),
            tcommon("May"),
            tcommon("Jun"),
            tcommon("Jul"),
            tcommon("Aug"),
            tcommon("Sep"),
            tcommon("Oct"),
            tcommon("Nov"),
            tcommon("Dec")
        ], [
        tcommon
    ]);
    const [getUserStatistics, { data , loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_USER_STATISTICS_WITH_ROLES */.m5i);
    const getLabel = (0,react.useCallback)((value)=>{
        switch(value){
            case "INTRAPRENEUR":
                return t("intrapreneur");
            case "EXTERNAL_USER":
                return t("external");
            case "ADMIN":
                return t("admin");
            default:
                return (0,util_src/* getLinkLabel */.en)(value === null || value === void 0 ? void 0 : value.toLowerCase());
        }
    }, [
        t
    ]);
    const convertJsonStructure = (0,react.useMemo)(()=>{
        const userStatistics = data === null || data === void 0 ? void 0 : data.userStatisticsWithRoles;
        if (!userStatistics) return [];
        return userStatistics.flatMap((param)=>{
            let { date , values  } = param;
            const totalCount = values.reduce((sum, param)=>{
                let { count  } = param;
                return sum + count;
            }, 0);
            const individualEntries = values.map((param)=>{
                let { role , count  } = param;
                return {
                    date,
                    role: getLabel(role),
                    count
                };
            });
            // Prepend the aggregated "All" entry
            return [
                {
                    date,
                    role: "All",
                    count: totalCount
                },
                ...individualEntries
            ];
        }).sort((a, b)=>new Date(a.date).getTime() - new Date(b.date).getTime());
    }, [
        data === null || data === void 0 ? void 0 : data.userStatisticsWithRoles,
        getLabel
    ]);
    const [selectedItems, setSelectedItems] = (0,react.useState)([]);
    const defaultSelectedItems = (0,react.useMemo)(()=>{
        if (convertJsonStructure.length > 0) {
            return convertJsonStructure.map((item)=>item.role);
        }
        return [];
    }, [
        convertJsonStructure
    ]);
    (0,react.useEffect)(()=>{
        setSelectedItems(defaultSelectedItems);
    }, [
        defaultSelectedItems
    ]);
    const config = (0,react.useMemo)(()=>{
        return {
            data: convertJsonStructure,
            loading,
            xField: "date",
            yField: "count",
            colorField: "role",
            seriesField: "role",
            yAxis: {
                label: {
                    style: {
                        fontFamily: "Lufga"
                    }
                }
            },
            xAxis: {
                label: {
                    style: {
                        fontFamily: "Lufga"
                    }
                },
                x: {
                    label: {
                        style: {
                            fontFamily: "Lufga"
                        }
                    },
                    labelFormatter: (v)=>{
                        const monthIndex = parseInt(v.split("-")[1], 10) - 1;
                        return monthNames[monthIndex];
                    }
                }
            },
            paddingTop: 32,
            legend: {
                color: {
                    position: "bottom",
                    autoWrap: true,
                    itemMarker: "square",
                    style: {
                        fontSize: 14,
                        fontFamily: "Lufga"
                    },
                    layout: {
                        justifyContent: "center",
                        alignItems: "center"
                    }
                }
            },
            onReady: (param)=>{
                let { chart  } = param;
                chart.on("legend:filter", (e)=>{
                    var ref;
                    if (e === null || e === void 0 ? void 0 : (ref = e.data) === null || ref === void 0 ? void 0 : ref.values) {
                        var ref1;
                        const values = e === null || e === void 0 ? void 0 : (ref1 = e.data) === null || ref1 === void 0 ? void 0 : ref1.values;
                        setSelectedItems([
                            ...values
                        ]);
                    }
                });
            },
            interactions: [
                {
                    type: "legend-filter"
                }
            ],
            animation: {
                appear: {
                    animation: "path-in",
                    duration: 100
                }
            },
            label: {
                text: "count",
                position: "top",
                textAlign: "center",
                dy: -10,
                style: {
                    fontFamily: "Lufga"
                }
            }
        };
    }, [
        convertJsonStructure,
        loading,
        monthNames
    ]);
    const visibleTotal = (0,react.useMemo)(()=>{
        if (selectedItems.includes("All")) {
            return convertJsonStructure.filter((item)=>item.role === "All").reduce((acc, curr)=>acc + curr.count, 0);
        } else {
            return convertJsonStructure.filter((item)=>item.role !== "All" && selectedItems.includes(item.role)).reduce((acc, curr)=>acc + curr.count, 0);
        }
    }, [
        convertJsonStructure,
        selectedItems
    ]);
    const handleChange = (dates, dateStrings)=>{
        if (dates) {
            setDate([
                dateStrings[0],
                dateStrings[1]
            ]);
        }
    };
    (0,react.useEffect)(()=>{
        if (date.length) {
            getUserStatistics({
                variables: {
                    input: {
                        startDate: date[0],
                        endDate: date[1]
                    }
                }
            });
        }
    }, [
        date,
        getUserStatistics
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            className: "flex items-center flex-wrap gap-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("total_during_period")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text-gray-700 font-medium",
                                    children: [
                                        "/ ",
                                        t("total_all_time")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalUsers_RangePicker, {
                                onChange: handleChange,
                                defaultValue: [
                                    dayjs_min_default()(date[0]),
                                    dayjs_min_default()(date[1])
                                ],
                                style: {
                                    borderRadius: 20
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center flex-wrap gap-1 my-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-gray-900 text-3xl",
                            children: visibleTotal
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-gray-700 text-2xl",
                            children: [
                                "/ ",
                                totalUsers === null || totalUsers === void 0 ? void 0 : (ref = totalUsers.totalUserCount) === null || ref === void 0 ? void 0 : ref.toLocaleString()
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(line/* default */.Z, {
                    ...config
                })
            ]
        })
    });
};
/* harmony default export */ var UsersGraphs_TotalUsers = (TotalUsers);

;// CONCATENATED MODULE: ./src/features/dashboard/components/InsightsGraphs/UsersEngagementStats.tsx







function UsersEngagementStats(param) {
    let { className  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        className: "".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap items-start gap-x-6 gap-y-4 mb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grow",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-medium text-base",
                            children: t("users_engagement")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/?graph=users",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-3 cursor-pointer rounded-lg px-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "rounded-full h-10 w-10 bg-primary-600 text-white text-center flex items-center justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_RiseOutlined, {
                                        size: 30
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-primary-600",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("view_more_details")
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid md:grid-cols-2 gap-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersGraphs_TotalUsers, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersGraphs_TopContributorsStats, {})
                ]
            })
        ]
    });
}
/* harmony default export */ var InsightsGraphs_UsersEngagementStats = (UsersEngagementStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/InsightsGraphs/index.tsx





function InsightsGraphs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid gap-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightsGraphs_UsersEngagementStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightsGraphs_PostsEngagementStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightsGraphs_CompaniesEngagementStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightsGraphs_IdeaEngagementStats, {})
        ]
    });
}
/* harmony default export */ var components_InsightsGraphs = (InsightsGraphs);

;// CONCATENATED MODULE: ./src/features/dashboard/components/IntraChallengesGraphs/ChallengeManagerStats.tsx







const states = [
    "open",
    "closed",
    "upcoming",
    "draft",
    "archived"
];
function ChallengeManagerStats(param) {
    let { className  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const [data, setData] = (0,react.useState)([]);
    const [selectedManagers, setSelectedManagers] = (0,react.useState)([]);
    const COLOR_PLATE_10 = [
        "#26D426",
        "#2888ED",
        "#62BAFC",
        "#36CBCB",
        "#525355",
        "#A3B1BF",
        "#8B8B8B",
        "#1890FF"
    ];
    const LABEL_MAP = (0,react.useMemo)(()=>{
        return {
            upcoming: [
                t("upcoming")
            ],
            draft: [
                t("draft")
            ],
            archived: [
                t("archived")
            ],
            open: [
                t("registration_open")
            ],
            closed: [
                t("registration_closed")
            ]
        };
    }, [
        t
    ]);
    const [getData, { loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_CHALLENGE_MANAGER_STATS */.XVb, {
        fetchPolicy: "no-cache",
        onCompleted: (data)=>{
            const result = [];
            var _getChallengeManagerStatistics;
            for (const item of (_getChallengeManagerStatistics = data.getChallengeManagerStatistics) !== null && _getChallengeManagerStatistics !== void 0 ? _getChallengeManagerStatistics : []){
                for (const value of states){
                    result.push({
                        name: item.user,
                        count: item[value],
                        state: LABEL_MAP[value]
                    });
                }
            }
            setData(result);
        }
    });
    (0,react.useEffect)(()=>{
        getData({
            variables: {
                order: true
            }
        });
    }, [
        getData
    ]);
    // Filter data based on the selected managers
    const filteredData = data.filter((item)=>selectedManagers.length > 0 ? selectedManagers.includes(item.name) : true);
    const config = {
        data: filteredData,
        stack: true,
        loading: loading,
        xField: "count",
        yField: "name",
        seriesField: "state",
        color: (param)=>{
            let { state  } = param;
            return COLOR_PLATE_10[state];
        },
        legend: {
            position: "bottom",
            flipPage: false
        },
        xAxis: {
            label: {
                style: {
                    fontFamily: "Lufga",
                    fill: "rgba(0, 0, 0, 0.65)"
                }
            }
        },
        yAxis: {
            label: {
                style: {
                    fontFamily: "Lufga",
                    fill: "rgba(0, 0, 0, 0.65)",
                    textAlign: "right"
                },
                labelFormatter: (value)=>{
                    const str = value.toString();
                    if (str.length > 30) {
                        return str.slice(0, 30) + "...";
                    }
                    return str;
                }
            },
            y: {
                label: {
                    style: {
                        fontFamily: "Lufga",
                        fill: "rgba(0, 0, 0, 0.65)"
                    }
                }
            }
        },
        label: {
            text: (param)=>{
                let { count  } = param;
                return count > 0 ? count : "";
            },
            position: "inside",
            style: {
                fontFamily: "Lufga"
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        className: "".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm text-gray-900 font-medium",
                                    children: t("challenge_managers")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-gray-700 font-normal",
                                    children: t("number_of_created_challenges")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                                mode: "multiple",
                                placeholder: t("select_challenge_managers"),
                                className: "!w-52",
                                value: selectedManagers,
                                onChange: (value)=>setSelectedManagers(value),
                                options: Array.from(new Set(data.map((item)=>item.name))).map((name)=>({
                                        label: name,
                                        value: name
                                    })),
                                allowClear: true,
                                maxTagCount: "responsive",
                                style: {
                                    borderRadius: 24
                                },
                                optionFilterProp: "label"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bar/* default */.Z, {
                    loading: loading,
                    ...config
                })
            ]
        })
    });
}
/* harmony default export */ var IntraChallengesGraphs_ChallengeManagerStats = (ChallengeManagerStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/IntraChallengesGraphs/IntraChallengeIdeasStats.tsx







const stateOptions = [
    {
        value: null,
        label: "All"
    },
    {
        value: "ACTIVE",
        label: "Registration open"
    },
    {
        value: "ENDED",
        label: "Registration closed"
    }
];
function IntraChallengeIdeasStats(param) {
    let { className  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { loading , data  } = (0,useQuery/* useQuery */.a)(src/* GET_CHALLENGE_APPLICATION_STATS */.CUg, {
        fetchPolicy: "no-cache",
        variables: {
            type: "INTERNAL",
            order: true,
            limit: 100
        }
    });
    const [challengeName, setChallengeName] = (0,react.useState)("");
    const [selectedState, setSelectedState] = (0,react.useState)(null);
    const [currentPage, setCurrentPage] = (0,react.useState)(1);
    const handleChallengeNameChange = (e)=>{
        setChallengeName(e.target.value);
    };
    const handleStateChange = (value)=>{
        setSelectedState(value);
    };
    // Filter data based on challenge name and state
    const filteredData = ((data === null || data === void 0 ? void 0 : data.getApplicationByRegistration) || []).filter((item)=>{
        const matchesName = item.challenge.toLowerCase().includes(challengeName.toLowerCase());
        const matchesState = selectedState ? item.registration === selectedState : true;
        return matchesName && matchesState;
    });
    const renderStatus = (state)=>{
        switch(state){
            case "ACTIVE":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("registration_open")
                });
            case "ENDED":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("registration_closed")
                });
            default:
                break;
        }
    };
    const columns = [
        {
            title: t("no"),
            dataIndex: "id",
            key: "id",
            width: 80,
            render: (_, __, index)=>{
                const actualIndex = (currentPage - 1) * 10 + index + 1;
                return "".concat(actualIndex, ".");
            }
        },
        {
            title: t("challenge_name"),
            dataIndex: "challenge",
            key: "challenge",
            width: 300,
            render: (_, param)=>/*#__PURE__*/ {
                let { id , challenge  } = param;
                return (0,jsx_runtime.jsx)((link_default()), {
                    href: "/intrapreneurship/challenge/".concat(id),
                    children: challenge
                });
            }
        },
        {
            title: t("status"),
            dataIndex: "registration",
            key: "registration",
            render: (record)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: renderStatus(record)
                })
        },
        {
            title: t("number_of_ideas"),
            dataIndex: "applications",
            key: "applications"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                            placeholder: t("search_challenge_name"),
                            className: "!w-64",
                            value: challengeName,
                            onChange: handleChallengeNameChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                            style: {
                                width: 180
                            },
                            placeholder: t("by_challenge_state"),
                            options: stateOptions,
                            onChange: handleStateChange
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default */.Z, {
                    rowKey: "id",
                    loading: loading,
                    columns: columns,
                    dataSource: filteredData,
                    pagination: {
                        pageSize: 10,
                        showSizeChanger: false,
                        current: currentPage,
                        onChange: (page)=>setCurrentPage(page),
                        total: filteredData.length
                    }
                })
            ]
        })
    });
}
/* harmony default export */ var IntraChallengesGraphs_IntraChallengeIdeasStats = (IntraChallengeIdeasStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/IntraChallengesGraphs/IntraChallengesByTopicStats.tsx







function IntraChallengesByTopicStats(param) {
    let { className  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const [filter, setFilter] = (0,react.useState)([]); // New state for search term
    const [getData, { data , loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_CHALLENGES_BY_TOPICS */.Sa_);
    (0,react.useEffect)(()=>{
        getData({
            variables: {
                input: {
                    type: "INTERNAL",
                    order: true
                }
            }
        });
    }, [
        getData
    ]);
    const filteredData = (data === null || data === void 0 ? void 0 : data.challengesByTopics.filter((item)=>filter.length > 0 ? filter.includes(item.topic) : true)) || [];
    const config = {
        data: filteredData,
        loading: loading,
        xField: "topic",
        yField: "count",
        color: "#529FF0",
        appendPadding: [
            0,
            20,
            0,
            0
        ],
        yAxis: {
            label: {
                formatter: (value)=>value.length > 30 ? value.slice(0, 30) + "..." : value,
                style: {
                    fontFamily: "Lufga",
                    fill: "rgba(0, 0, 0, 0.65)",
                    textAlign: "right"
                },
                labelFormatter: (value)=>value.length > 30 ? value.slice(0, 30) + "..." : value
            }
        },
        label: {
            text: "count",
            position: "right",
            textAlign: "start",
            dx: 8,
            style: {
                fill: "rgba(0, 0, 0, 0.65)",
                fontFamily: "Lufga"
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        className: "".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-sm font-medium",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-gray-900",
                                    children: t("intra_challenges_by_topic")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-gray-700",
                                    children: t("by_number_of_created_challenges")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                                onChange: setFilter,
                                options: data === null || data === void 0 ? void 0 : data.challengesByTopics.map((item)=>({
                                        label: item.topic,
                                        value: item.topic
                                    })),
                                value: filter,
                                placeholder: t("search_by_topics"),
                                allowClear: true,
                                mode: "multiple",
                                className: "!w-56",
                                maxTagCount: "responsive",
                                optionFilterProp: "label"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bar/* default */.Z, {
                    ...config
                })
            ]
        })
    });
}
/* harmony default export */ var IntraChallengesGraphs_IntraChallengesByTopicStats = (IntraChallengesByTopicStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/IntraChallengesGraphs/TotalIntraChallengeStats.tsx








const { RangePicker: TotalIntraChallengeStats_RangePicker  } = date_picker/* default */.Z;
var ChallengeState;
(function(ChallengeState) {
    ChallengeState["OPEN"] = "OPEN";
    ChallengeState["INTERNAL"] = "INTERNAL";
})(ChallengeState || (ChallengeState = {}));
const TotalIntraChallengeStats_COLOR_PLATE_10 = [
    "#00CC00",
    "#2FC25B",
    "#2888ED",
    "#62BAFC",
    "#36CBCB",
    "#525355"
];
const TotalIntraChallengeStats = ()=>{
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { t: tcommon  } = (0,useTranslation/* default */.Z)("common");
    const [data, setData] = (0,react.useState)([]);
    const endDate = dayjs_min_default()();
    const startDate = endDate.subtract(3, "month");
    const [date, setDate] = (0,react.useState)([
        startDate.format("YYYY-MM-DD"),
        endDate.format("YYYY-MM-DD")
    ]);
    const monthNames = (0,react.useMemo)(()=>[
            tcommon("Jan"),
            tcommon("Feb"),
            tcommon("Mar"),
            tcommon("Apr"),
            tcommon("May"),
            tcommon("Jun"),
            tcommon("Jul"),
            tcommon("Aug"),
            tcommon("Sep"),
            tcommon("Oct"),
            tcommon("Nov"),
            tcommon("Dec")
        ], [
        tcommon
    ]);
    const statusOptionsMap = (0,react.useMemo)(()=>new Map([
            [
                "ACTIVE",
                t("registration_open")
            ],
            [
                "ENDED",
                t("registration_closed")
            ],
            [
                "UPCOMING",
                t("upcoming")
            ],
            [
                "DRAFT",
                t("draft")
            ],
            [
                "ARCHIVED",
                t("archived")
            ]
        ]), [
        t
    ]);
    const stateOrder = (0,react.useMemo)(()=>[
            t("all"),
            t("registration_open"),
            t("registration_closed"),
            t("upcoming"),
            t("draft"),
            t("archived")
        ], [
        t
    ]);
    const { data: dataTotal  } = (0,useQuery/* useQuery */.a)(src/* GET_TOTAL_CHALLENGES_COUNT */.XIo, {
        variables: {
            type: ChallengeState.INTERNAL
        }
    });
    const [getData, { loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_TOTAL_CHALLENGES */.cNF, {
        fetchPolicy: "no-cache",
        onCompleted: (data)=>{
            const sortedStatistics = data.challengeStatisticsByState.sort((a, b)=>new Date(a.date).getTime() - new Date(b.date).getTime());
            const result = [];
            for (const state of sortedStatistics){
                let all = 0;
                for (const value of state.values){
                    all += value.count;
                    result.push({
                        name: getStateName(value.state),
                        date: state.date,
                        value: value.count
                    });
                }
                result.push({
                    name: "All",
                    date: state.date,
                    value: all
                });
            }
            const sortedResult = result.sort((a, b)=>stateOrder.indexOf(a.name) - stateOrder.indexOf(b.name));
            setData(sortedResult);
        }
    });
    (0,react.useEffect)(()=>{
        if (date.length) {
            getData({
                variables: {
                    input: {
                        startDate: date[0],
                        endDate: date[1],
                        type: ChallengeState.INTERNAL
                    }
                }
            });
        }
    }, [
        date,
        getData
    ]);
    const getStateName = (state)=>{
        return statusOptionsMap.get(state) || state;
    };
    const [selectedItems, setSelectedItems] = (0,react.useState)([]);
    const defaultSelectedItems = (0,react.useMemo)(()=>{
        if (data.length > 0) {
            return data.map((item)=>item.name);
        }
        return [];
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        setSelectedItems(defaultSelectedItems);
    }, [
        defaultSelectedItems
    ]);
    const config = (0,react.useMemo)(()=>{
        return {
            data: data,
            xField: "date",
            yField: "value",
            seriesField: "name",
            colorField: "name",
            loading: loading,
            animate: {
                enter: {
                    type: "pathIn"
                }
            },
            style: {
                lineWidth: 2
            },
            axis: {
                x: {
                    labelFormatter: (v)=>{
                        const monthIndex = parseInt(v.split("-")[1], 10) - 1;
                        return monthNames[monthIndex];
                    }
                }
            },
            legend: {
                color: {
                    position: "bottom",
                    autoWrap: true,
                    itemMarker: "square",
                    style: {
                        fontSize: 14,
                        fontFamily: "Lufga"
                    },
                    layout: {
                        justifyContent: "center",
                        alignItems: "center"
                    }
                }
            },
            onReady: (param)=>{
                let { chart  } = param;
                chart.on("legend:filter", (e)=>{
                    var ref;
                    if (e === null || e === void 0 ? void 0 : (ref = e.data) === null || ref === void 0 ? void 0 : ref.values) {
                        var ref1;
                        const values = e === null || e === void 0 ? void 0 : (ref1 = e.data) === null || ref1 === void 0 ? void 0 : ref1.values;
                        setSelectedItems([
                            ...values
                        ]);
                    }
                });
            },
            interactions: [
                {
                    type: "legend-filter"
                }
            ],
            animation: {
                appear: {
                    animation: "path-in",
                    duration: 5000
                }
            },
            label: {
                text: "value",
                position: "top",
                textAlign: "center",
                dy: -10,
                style: {
                    fontFamily: "Lufga"
                }
            },
            scale: {
                color: {
                    range: TotalIntraChallengeStats_COLOR_PLATE_10
                }
            }
        };
    }, [
        data,
        loading,
        monthNames
    ]);
    const visibleTotal = (0,react.useMemo)(()=>{
        if (selectedItems.includes("All")) {
            return data.filter((item)=>item.name === "All").reduce((acc, curr)=>acc + curr.value, 0);
        } else {
            return data.filter((item)=>item.name !== "All" && selectedItems.includes(item.name)).reduce((acc, curr)=>acc + curr.value, 0);
        }
    }, [
        data,
        selectedItems
    ]);
    const handleChange = (dates, dateStrings)=>{
        if (dates) {
            setDate([
                dateStrings[0],
                dateStrings[1]
            ]);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row flex-wrap justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "flex items-center flex-wrap gap-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("total_during_period")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-gray-700 font-medium",
                                children: [
                                    "/ ",
                                    t("total_all_time")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalIntraChallengeStats_RangePicker, {
                            onChange: handleChange,
                            defaultValue: [
                                dayjs_min_default()(date[0]),
                                dayjs_min_default()(date[1])
                            ],
                            style: {
                                borderRadius: 20
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center flex-wrap gap-1 my-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-gray-900 text-3xl",
                        children: visibleTotal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-gray-700 text-2xl",
                        children: [
                            "/ ",
                            dataTotal === null || dataTotal === void 0 ? void 0 : dataTotal.totalChallengesCount
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(line/* default */.Z, {
                ...config
            })
        ]
    });
};
/* harmony default export */ var IntraChallengesGraphs_TotalIntraChallengeStats = (TotalIntraChallengeStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/IntraChallengesGraphs/index.tsx





function IntraChallengesGraphs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid md:grid-cols-2 gap-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntraChallengesGraphs_TotalIntraChallengeStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntraChallengesGraphs_IntraChallengesByTopicStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntraChallengesGraphs_IntraChallengeIdeasStats, {
                className: "col-span-2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntraChallengesGraphs_ChallengeManagerStats, {})
        ]
    });
}
/* harmony default export */ var components_IntraChallengesGraphs = (IntraChallengesGraphs);

;// CONCATENATED MODULE: ./src/features/dashboard/components/OpenChallengesGraphs/ChallengeByApplicationStats.tsx








const ChallengeByApplicationStats = (param)=>{
    let { className  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const [filter, setFilter] = (0,react.useState)([]);
    const [registrationStatus, setRegistrationStatus] = (0,react.useState)("ALL");
    const [currentPage, setCurrentPage] = (0,react.useState)(1);
    const stateOptions = (0,react.useMemo)(()=>[
            {
                value: "ALL",
                label: t("all")
            },
            {
                value: "ACTIVE",
                label: t("registration_open")
            },
            {
                value: "ENDED",
                label: t("registration_closed")
            }
        ], [
        t
    ]);
    const { loading , data  } = (0,useQuery/* useQuery */.a)(src/* GET_CHALLENGE_APPLICATION_STATS */.CUg, {
        variables: {
            type: "OPEN",
            order: true,
            limit: 100
        }
    });
    const renderStatus = (state)=>{
        switch(state){
            case "ACTIVE":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("registration_open")
                });
            case "ENDED":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("registration_closed")
                });
            default:
                break;
        }
    };
    const columns = [
        {
            title: t("no"),
            dataIndex: "id",
            key: "id",
            width: 80,
            render: (_, __, index)=>{
                const actualIndex = (currentPage - 1) * 10 + index + 1;
                return "".concat(actualIndex, ".");
            }
        },
        {
            title: t("challenge_name"),
            dataIndex: "challenge",
            key: "challenge",
            width: 300,
            render: (_, param)=>/*#__PURE__*/ {
                let { challenge , id  } = param;
                return (0,jsx_runtime.jsx)((link_default()), {
                    href: "/entrepreneurship/challenge/".concat(id),
                    children: challenge
                });
            }
        },
        {
            title: t("status"),
            dataIndex: "registration",
            key: "registration",
            render: (record)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: renderStatus(record)
                })
        },
        {
            title: t("submitted_applications"),
            dataIndex: "applications",
            key: "applications"
        },
        {
            title: t("companies"),
            dataIndex: "companies",
            key: "companies"
        },
        {
            title: t("profile_managers"),
            dataIndex: "profileManagers",
            key: "profileManagers",
            render: (_, param)=>{
                let { profileOwners  } = param;
                return (profileOwners === null || profileOwners === void 0 ? void 0 : profileOwners.length) || "0";
            }
        }
    ];
    const filteredData = (0,react.useMemo)(()=>{
        if (!(data === null || data === void 0 ? void 0 : data.getApplicationByRegistration)) {
            return [];
        }
        let filtered = data.getApplicationByRegistration;
        if (filter.length > 0) {
            filtered = filtered.filter((item)=>filter.some((text)=>item.challenge.toLowerCase().includes(text.toLowerCase())));
        }
        if (registrationStatus !== "ALL") {
            filtered = filtered.filter((item)=>item.registration === registrationStatus);
        }
        return filtered;
    }, [
        data,
        filter,
        registrationStatus
    ]);
    const challengeOptions = (0,react.useMemo)(()=>{
        if (!(data === null || data === void 0 ? void 0 : data.getApplicationByRegistration)) {
            return [];
        }
        return data.getApplicationByRegistration.map((item)=>({
                label: item.challenge,
                value: item.challenge
            }));
    }, [
        data
    ]);
    const handleRegistrationStatusChange = (status)=>{
        setRegistrationStatus(status);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        className: "".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-4 mb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                        onChange: setFilter,
                        options: challengeOptions,
                        value: filter,
                        placeholder: t("search_challenge_name"),
                        allowClear: true,
                        mode: "multiple",
                        className: "!w-56",
                        maxTagCount: "responsive",
                        suffixIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchOutlined/* default */.Z, {}),
                        optionFilterProp: "label"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                        style: {
                            width: 180
                        },
                        placeholder: t("by_challenge_state"),
                        options: stateOptions,
                        onChange: handleRegistrationStatusChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default */.Z, {
                rowKey: "id",
                columns: columns,
                loading: loading,
                className: className,
                dataSource: filteredData,
                pagination: {
                    pageSize: 10,
                    showSizeChanger: false,
                    current: currentPage,
                    onChange: (page)=>setCurrentPage(page),
                    total: filteredData.length
                }
            })
        ]
    });
};
/* harmony default export */ var OpenChallengesGraphs_ChallengeByApplicationStats = (ChallengeByApplicationStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/OpenChallengesGraphs/ChallengesByTopicStats.tsx







const ChallengesByTopicStats = (param)=>{
    let { className  } = param;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const [data, setData] = (0,react.useState)([]);
    const [selectedTopics, setSelectedTopics] = (0,react.useState)([]);
    const { data: queryData , loading  } = (0,useQuery/* useQuery */.a)(src/* GET_CHALLENGES_BY_TOPICS */.Sa_, {
        variables: {
            input: {
                type: "OPEN",
                order: true
            }
        }
    });
    (0,react.useEffect)(()=>{
        if (queryData === null || queryData === void 0 ? void 0 : queryData.challengesByTopics) {
            setData(queryData.challengesByTopics);
        }
    }, [
        queryData
    ]);
    const filteredData = (0,react.useMemo)(()=>{
        if (selectedTopics.length === 0) return data;
        return data.filter((item)=>selectedTopics.includes(item.topic));
    }, [
        data,
        selectedTopics
    ]);
    const config = {
        data: filteredData,
        loading,
        xField: "topic",
        yField: "count",
        color: "#3BA1FF",
        appendPadding: [
            0,
            20,
            0,
            0
        ],
        legend: {
            position: "bottom",
            flipPage: false
        },
        yAxis: {
            label: {
                formatter: (value)=>value.length > 30 ? value.slice(0, 30) + "..." : value,
                style: {
                    fontFamily: "Lufga",
                    fill: "rgba(0, 0, 0, 0.65)",
                    textAlign: "right"
                },
                labelFormatter: (value)=>value.length > 30 ? value.slice(0, 30) + "..." : value
            }
        },
        label: {
            text: "count",
            position: "right",
            textAlign: "start",
            dx: 8,
            style: {
                fill: "rgba(0, 0, 0, 0.65)",
                fontFamily: "Lufga"
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        className: "".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-sm text-gray-900 font-medium",
                            children: t("open_challenge_by_topics")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                                mode: "multiple",
                                style: {
                                    width: 300
                                },
                                placeholder: t("select_topics"),
                                value: selectedTopics,
                                onChange: setSelectedTopics,
                                options: data.map((item)=>({
                                        value: item.topic,
                                        label: item.topic
                                    })),
                                maxTagCount: "responsive",
                                allowClear: true,
                                optionFilterProp: "label"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bar/* default */.Z, {
                    ...config
                })
            ]
        })
    });
};
/* harmony default export */ var OpenChallengesGraphs_ChallengesByTopicStats = (ChallengesByTopicStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/OpenChallengesGraphs/TotalChallenges.tsx








const { RangePicker: TotalChallenges_RangePicker  } = date_picker/* default */.Z;
var TotalChallenges_ChallengeState;
(function(ChallengeState) {
    ChallengeState["OPEN"] = "OPEN";
    ChallengeState["INTERNAL"] = "INTERNAL";
})(TotalChallenges_ChallengeState || (TotalChallenges_ChallengeState = {}));
const TotalChallenges_COLOR_PLATE_10 = [
    "#00CC00",
    "#2FC25B",
    "#2888ED",
    "#62BAFC",
    "#36CBCB",
    "#525355"
];
const TotalOpenChallengeStats = ()=>{
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { t: tcommon  } = (0,useTranslation/* default */.Z)("common");
    const [data, setData] = (0,react.useState)([]);
    const endDate = dayjs_min_default()();
    const startDate = endDate.subtract(3, "month");
    const [dates, setDates] = (0,react.useState)([
        startDate.format("YYYY-MM-DD"),
        endDate.format("YYYY-MM-DD")
    ]);
    const statusOptions = (0,react.useMemo)(()=>[
            {
                label: t("registration_open"),
                value: "ACTIVE"
            },
            {
                label: t("registration_closed"),
                value: "ENDED"
            },
            {
                label: t("upcoming"),
                value: "UPCOMING"
            },
            {
                label: t("draft"),
                value: "DRAFT"
            },
            {
                label: t("archived"),
                value: "ARCHIVED"
            }
        ], [
        t
    ]);
    const monthNames = (0,react.useMemo)(()=>[
            tcommon("Jan"),
            tcommon("Feb"),
            tcommon("Mar"),
            tcommon("Apr"),
            tcommon("May"),
            tcommon("Jun"),
            tcommon("Jul"),
            tcommon("Aug"),
            tcommon("Sep"),
            tcommon("Oct"),
            tcommon("Nov"),
            tcommon("Dec")
        ], [
        tcommon
    ]);
    const { data: dataTotal  } = (0,useQuery/* useQuery */.a)(src/* GET_TOTAL_CHALLENGES_COUNT */.XIo, {
        variables: {
            type: TotalChallenges_ChallengeState.OPEN
        }
    });
    const [gatData, { loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_TOTAL_CHALLENGES */.cNF, {
        fetchPolicy: "no-cache",
        onCompleted: (data)=>{
            const sortedStatistics = data.challengeStatisticsByState.sort((a, b)=>new Date(a.date).getTime() - new Date(b.date).getTime());
            const aggregatedData = [];
            const result = [];
            // Add entries for each status and accumulate counts for each date
            for (const state of sortedStatistics){
                let totalValue = 0;
                // Collect individual status data and accumulate for aggregation
                for (const status of statusOptions){
                    const value = state.values.find((v)=>v.state === status.value);
                    if (value) {
                        result.push({
                            name: status.label,
                            date: state.date,
                            value: value.count
                        });
                        totalValue += value.count;
                    }
                }
                // Add the aggregated "all" count entry for each date
                aggregatedData.push({
                    name: "All",
                    date: state.date,
                    value: totalValue
                });
            }
            const finalResult = [
                ...aggregatedData,
                ...result
            ];
            setData(finalResult);
        }
    });
    (0,react.useEffect)(()=>{
        if (!dates) return;
        gatData({
            variables: {
                input: {
                    startDate: dates[0],
                    endDate: dates[1],
                    type: TotalChallenges_ChallengeState.OPEN
                }
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dates
    ]);
    const [selectedItems, setSelectedItems] = (0,react.useState)([]);
    const defaultSelectedItems = (0,react.useMemo)(()=>{
        if (data.length > 0) {
            return data.map((item)=>item.name);
        }
        return [];
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        setSelectedItems(defaultSelectedItems);
    }, [
        defaultSelectedItems
    ]);
    const config = (0,react.useMemo)(()=>{
        return {
            data: data,
            xField: "date",
            yField: "value",
            seriesField: "name",
            colorField: "name",
            loading: loading,
            animate: {
                enter: {
                    type: "pathIn"
                }
            },
            style: {
                lineWidth: 2
            },
            axis: {
                x: {
                    labelFormatter: (v)=>{
                        const monthIndex = parseInt(v.split("-")[1], 10) - 1;
                        return monthNames[monthIndex];
                    }
                }
            },
            legend: {
                color: {
                    position: "bottom",
                    autoWrap: true,
                    itemMarker: "square",
                    style: {
                        fontSize: 14,
                        fontFamily: "Lufga"
                    },
                    layout: {
                        justifyContent: "center",
                        alignItems: "center"
                    }
                }
            },
            onReady: (param)=>{
                let { chart  } = param;
                chart.on("legend:filter", (e)=>{
                    var ref;
                    if (e === null || e === void 0 ? void 0 : (ref = e.data) === null || ref === void 0 ? void 0 : ref.values) {
                        var ref1;
                        const values = e === null || e === void 0 ? void 0 : (ref1 = e.data) === null || ref1 === void 0 ? void 0 : ref1.values;
                        setSelectedItems([
                            ...values
                        ]);
                    }
                });
            },
            interactions: [
                {
                    type: "legend-filter"
                }
            ],
            animation: {
                appear: {
                    animation: "path-in",
                    duration: 5000
                }
            },
            label: {
                text: "value",
                position: "top",
                textAlign: "center",
                dy: -10,
                style: {
                    fontFamily: "Lufga"
                }
            },
            scale: {
                color: {
                    range: TotalChallenges_COLOR_PLATE_10
                }
            }
        };
    }, [
        data,
        loading,
        monthNames
    ]);
    const visibleTotal = (0,react.useMemo)(()=>{
        if (selectedItems.includes("All")) {
            return data.filter((item)=>item.name === "All").reduce((acc, curr)=>acc + curr.value, 0);
        } else {
            return data.filter((item)=>item.name !== "All" && selectedItems.includes(item.name)).reduce((acc, curr)=>acc + curr.value, 0);
        }
    }, [
        data,
        selectedItems
    ]);
    const handleChange = (dates, dateStrings)=>{
        if (dates) {
            setDates([
                dateStrings[0],
                dateStrings[1]
            ]);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "flex items-center flex-wrap gap-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("total_during_period")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-gray-700 font-medium",
                                children: [
                                    "/ ",
                                    t("total_all_time")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalChallenges_RangePicker, {
                            onChange: handleChange,
                            defaultValue: [
                                dayjs_min_default()(dates[0]),
                                dayjs_min_default()(dates[1])
                            ],
                            style: {
                                borderRadius: 20
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center flex-wrap gap-1 my-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-gray-900 text-3xl",
                        children: visibleTotal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-gray-700 text-2xl",
                        children: [
                            "/ ",
                            dataTotal === null || dataTotal === void 0 ? void 0 : dataTotal.totalChallengesCount
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(line/* default */.Z, {
                ...config
            })
        ]
    });
};
/* harmony default export */ var TotalChallenges = (TotalOpenChallengeStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/OpenChallengesGraphs/index.tsx




function OpenChallengesGraphs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid md:grid-cols-2 gap-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalChallenges, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenChallengesGraphs_ChallengesByTopicStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenChallengesGraphs_ChallengeByApplicationStats, {
                className: "col-span-2"
            })
        ]
    });
}
/* harmony default export */ var components_OpenChallengesGraphs = (OpenChallengesGraphs);

;// CONCATENATED MODULE: ./src/features/dashboard/components/TrendGraphs/TrendingRegionStats.tsx






function TrendingRegionStats() {
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { data , loading  } = (0,useQuery/* useQuery */.a)(src/* GET_TRENDING_REGION */.dr5);
    const COLOR_PLATE_10 = [
        "#0273EA",
        "#00CC00",
        "#B1BDC9",
        "#7AC4FC",
        "#C5F1BB",
        "#A3B1BF",
        "#8B8B8B",
        "#1890FF"
    ];
    var ref;
    const config = {
        data: (ref = data === null || data === void 0 ? void 0 : data.dashboardTrendingRegions) !== null && ref !== void 0 ? ref : [],
        loading,
        isStack: true,
        xField: "value",
        yField: "name",
        seriesField: "type",
        legend: {
            position: "bottom",
            flipPage: false
        },
        xAxis: {
            label: {
                style: {
                    fontFamily: "Lufga"
                }
            }
        },
        yAxis: {
            label: {
                style: {
                    fontFamily: "Lufga"
                }
            }
        },
        label: {
            text: (param)=>{
                let { value  } = param;
                return value > 0 ? value : "";
            },
            textBaseline: "bottom",
            position: "inside",
            style: {
                fill: "rgba(255, 255, 255, 1)",
                fontFamily: "Lufga"
            }
        },
        scale: {
            color: {
                range: COLOR_PLATE_10
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-sm text-gray-900 font-medium",
                    children: t("trending_region_stats")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bar/* default */.Z, {
                    ...config
                })
            ]
        })
    });
}
/* harmony default export */ var TrendGraphs_TrendingRegionStats = (TrendingRegionStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/TrendGraphs/TrendingTopicsStats.tsx






function TrendingTopicsStats() {
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { data , loading  } = (0,useQuery/* useQuery */.a)(src/* GET_TRENDING_TOPICS */.y8P);
    const COLOR_PLATE_10 = [
        "#0273EA",
        "#00CC00",
        "#B1BDC9",
        "#7AC4FC",
        "#C5F1BB",
        "#A3B1BF",
        "#8B8B8B",
        "#1890FF"
    ];
    const config = {
        data: (data === null || data === void 0 ? void 0 : data.dashboardTrendingTopics) || [],
        loading,
        isStack: true,
        xField: "value",
        yField: "name",
        seriesField: "type",
        legend: {
            position: "bottom",
            flipPage: false
        },
        xAxis: {
            label: {
                style: {
                    fontFamily: "Lufga",
                    fill: "rgba(0, 0, 0, 0.65)"
                },
                labelFormatter: (value)=>value.length > 30 ? value.slice(0, 30) + "..." : value
            }
        },
        label: {
            text: (param)=>{
                let { value  } = param;
                return value > 0 ? value : "";
            },
            textBaseline: "bottom",
            position: "inside",
            style: {
                fill: "rgba(255, 255, 255, 1)",
                fontFamily: "Lufga"
            }
        },
        scale: {
            color: {
                range: COLOR_PLATE_10
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-sm text-gray-900 font-medium",
                    children: t("trending_topics")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bar/* default */.Z, {
                    ...config
                })
            ]
        })
    });
}
/* harmony default export */ var TrendGraphs_TrendingTopicsStats = (TrendingTopicsStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/TrendGraphs/index.tsx



function TrendGraphs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid gap-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendGraphs_TrendingTopicsStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendGraphs_TrendingRegionStats, {})
        ]
    });
}
/* harmony default export */ var components_TrendGraphs = (TrendGraphs);

;// CONCATENATED MODULE: ./src/features/dashboard/components/UsersGraphs/PopularTopicsStats.tsx







const UsersGraphs_PopularTopicsStats_PopularTopicsStats = (param)=>{
    let { className  } = param;
    var ref;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const [topicFilter, setTopicFilter] = (0,react.useState)([]);
    const [topics, setTopics] = (0,react.useState)([]);
    const { data , loading  } = (0,useQuery/* useQuery */.a)(src/* GET_POPULAR_TOPICS */.Gj0, {
        variables: {
            limit: 50
        },
        onCompleted: (data)=>{
            setTopics(data.popularTopics);
        }
    });
    const config = {
        data: topics,
        loading,
        xField: "count",
        yField: "topic",
        color: "#3BA1FF",
        appendPadding: [
            0,
            20,
            0,
            0
        ],
        yAxis: {
            label: {
                formatter: (value)=>value.length > 30 ? value.slice(0, 30) + "..." : value,
                style: {
                    fontFamily: "Lufga",
                    fill: "rgba(0, 0, 0, 0.65)",
                    textAlign: "right"
                },
                labelFormatter: (value)=>value.length > 30 ? value.slice(0, 30) + "..." : value
            }
        },
        label: {
            text: "count",
            position: "right",
            textAlign: "start",
            dx: 8,
            style: {
                fill: "rgba(0, 0, 0, 0.65)",
                fontFamily: "Lufga"
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        className: "".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-sm text-gray-900 font-medium",
                            children: t("users_by_topics")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                            className: "!w-[300px]",
                            onChange: (value)=>setTopicFilter(value),
                            options: data === null || data === void 0 ? void 0 : (ref = data.popularTopics) === null || ref === void 0 ? void 0 : ref.map((item)=>({
                                    label: item.topic,
                                    value: item.topic
                                })),
                            value: topicFilter,
                            placeholder: t("filter_by_topic"),
                            allowClear: true,
                            mode: "multiple",
                            style: {
                                width: "100%",
                                borderRadius: 20
                            },
                            maxTagCount: "responsive",
                            optionFilterProp: "label"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bar/* default */.Z, {
                    ...config,
                    data: topics.filter((item)=>{
                        return (topicFilter === null || topicFilter === void 0 ? void 0 : topicFilter.length) === 0 || topicFilter.includes(item === null || item === void 0 ? void 0 : item.topic);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var UsersGraphs_PopularTopicsStats = (UsersGraphs_PopularTopicsStats_PopularTopicsStats);

;// CONCATENATED MODULE: ./src/features/dashboard/components/UsersGraphs/UsersByCompanyAffiliation.tsx







const UsersByCompanyAffiliation = ()=>{
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { data , loading  } = (0,useQuery/* useQuery */.a)(src/* GET_USER_COMPANY_AFFILIATION */.$FW);
    const [stats, setStats] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        if (data === null || data === void 0 ? void 0 : data.userCompanyAffiliation) {
            setStats([
                {
                    count: data === null || data === void 0 ? void 0 : data.userCompanyAffiliation.withCompanies,
                    role: t("company_user")
                },
                {
                    count: data === null || data === void 0 ? void 0 : data.userCompanyAffiliation.withoutCompanies,
                    role: t("individual_user")
                }
            ]);
        }
    }, [
        data,
        t
    ]);
    const config = {
        data: stats,
        xField: "role",
        yField: "count",
        colorField: "role",
        paddingTop: 32,
        axis: {
            x: {
                label: {
                    autoHide: true,
                    autoRotate: false
                }
            }
        },
        meta: {
            role: {
                alias: t("role")
            },
            count: {
                alias: t("user_count")
            }
        },
        loading,
        scale: {
            color: {
                range: [
                    "#47DA47",
                    "#529FF0"
                ]
            }
        },
        label: {
            text: "count",
            position: "top",
            textAlign: "center",
            dy: -15,
            style: {
                fill: "rgba(0, 0, 0, 0.65)",
                fontFamily: "Lufga"
            }
        },
        legend: false
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "font-medium mb-4",
                    children: t("external_user_by_institution_affiliation")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(column/* default */.Z, {
                    ...config
                }, "users-by-company")
            ]
        })
    });
};
/* harmony default export */ var UsersGraphs_UsersByCompanyAffiliation = (UsersByCompanyAffiliation);

;// CONCATENATED MODULE: ./src/features/dashboard/components/UsersGraphs/UsersByCountry.tsx







const UsersByCountry_WorldMapDynamic = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(156), __webpack_require__.e(2538), __webpack_require__.e(7827), __webpack_require__.e(5293), __webpack_require__.e(2371), __webpack_require__.e(1819)]).then(__webpack_require__.bind(__webpack_require__, 21819)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(21819)
            ]
    },
    ssr: false
});
const UsersByCountry = ()=>{
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { data , loading  } = (0,useQuery/* useQuery */.a)(src/* GET_USER_LOCATION_ALL */.HI4);
    const columns = (0,react.useMemo)(()=>[
            {
                title: t("country"),
                dataIndex: "country",
                key: "country"
            },
            {
                title: t("users"),
                dataIndex: "all",
                key: "all"
            }
        ], [
        t
    ]);
    const stats = (0,react.useMemo)(()=>{
        var ref;
        return (data === null || data === void 0 ? void 0 : (ref = data.userCountryRatioAll) === null || ref === void 0 ? void 0 : ref.filter((item)=>item.country).map((item)=>({
                country: item.country,
                count: item.all
            })).sort((a, b)=>b.count - a.count)) || [];
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-between",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-sm text-gray-900 font-medium",
                        children: t("users_by_country")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Loading..."
                    }),
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersByCountry_WorldMapDynamic, {
                        loading: loading,
                        stats: stats
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default */.Z, {
                    size: "small",
                    rowKey: "country",
                    dataSource: (data === null || data === void 0 ? void 0 : data.userCountryRatioAll) || [],
                    columns: columns,
                    pagination: false
                })
            ]
        })
    });
};
/* harmony default export */ var UsersGraphs_UsersByCountry = (UsersByCountry);

;// CONCATENATED MODULE: ./src/features/dashboard/components/UsersGraphs/UsersByCountryInsight.tsx








const { Option: UsersByCountryInsight_Option  } = es_select/* default */.Z;
const UsersByCountryInsight = ()=>{
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const [filterPeriod, setFilterPeriod] = (0,react.useState)("week");
    const [searchText, setSearchText] = (0,react.useState)("");
    const [data, setData] = (0,react.useState)([]);
    const [prevData, setPrevData] = (0,react.useState)([]);
    const [getData, { loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_USER_COUNTRY_RATIO */.nSV, {
        fetchPolicy: "no-cache"
    });
    (0,react.useEffect)(()=>{
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        getData,
        filterPeriod
    ]);
    const fetchData = async ()=>{
        const { startDate , endDate  } = getDateRange(filterPeriod, dayjs_min_default()());
        await getData({
            variables: {
                startDate,
                endDate
            }
        }).then((param)=>{
            let { data  } = param;
            setData(data === null || data === void 0 ? void 0 : data.userCountryRatio);
        });
        const { startDate: startDate1 , endDate: endDate1  } = getDateRange(filterPeriod, dayjs_min_default()(startDate));
        await getData({
            variables: {
                startDate: startDate1,
                endDate: endDate1
            }
        }).then((param)=>{
            let { data  } = param;
            setPrevData(data === null || data === void 0 ? void 0 : data.userCountryRatio);
        });
    };
    const getDateRange = (period, endDate)=>{
        let startDate = dayjs_min_default()();
        switch(period){
            case "week":
                startDate = endDate.clone().subtract(7, "day");
                break;
            case "month":
                startDate = endDate.clone().subtract(1, "month");
                break;
            case "quarter":
                startDate = endDate.clone().subtract(3, "month");
                break;
            case "year":
                startDate = endDate.clone().subtract(1, "year");
                break;
        }
        return {
            startDate: startDate.format("YYYY-MM-DD"),
            endDate: endDate.format("YYYY-MM-DD")
        };
    };
    const getPercentChange = (value, prevValue)=>{
        if (prevValue === 0 && value === 0) {
            return 0;
        }
        if (prevValue === 0) {
            return 100;
        }
        return (value - prevValue) / prevValue * 100;
    };
    const stats = (0,react.useMemo)(()=>{
        return (data === null || data === void 0 ? void 0 : data.filter((item)=>item.country).map((item)=>{
            const prevItem = prevData.find((prevItem)=>prevItem.country === item.country);
            return {
                country: item.country,
                users: item.count,
                change: getPercentChange(item.count, (prevItem === null || prevItem === void 0 ? void 0 : prevItem.count) || 0)
            };
        })) || [];
    }, [
        data,
        prevData
    ]);
    const filteredStats = (0,react.useMemo)(()=>{
        return stats.filter((item)=>item.country.toLowerCase().includes(searchText.toLowerCase()));
    }, [
        stats,
        searchText
    ]);
    const columns = (0,react.useMemo)(()=>[
            {
                title: t("country"),
                dataIndex: "country",
                key: "country",
                width: "60%"
            },
            {
                title: t("users"),
                dataIndex: "users",
                key: "users",
                width: "20%"
            },
            {
                title: t("percent_change"),
                dataIndex: "change",
                key: "change",
                width: "20%",
                render: (change)=>{
                    const isPositive = change >= 0;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "inline-block px-2 py-1 rounded-full font-medium text-sm ".concat(isPositive ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"),
                        children: [
                            isPositive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretUpOutlined/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretDownOutlined/* default */.Z, {}),
                            " ",
                            Math.round(change),
                            "%"
                        ]
                    });
                }
            }
        ], [
        t
    ]);
    const handleFilterChange = (value)=>{
        setFilterPeriod(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col space-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-sm text-gray-900 font-medium",
                            children: t("user_growth_by_country")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex space-x-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                    placeholder: t("country_name"),
                                    value: searchText,
                                    onChange: (e)=>setSearchText(e.target.value),
                                    className: "flex-grow",
                                    style: {
                                        height: "40px"
                                    },
                                    suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchOutlined/* default */.Z, {
                                        style: {
                                            color: "rgba(0,0,0,.45)"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_select/* default */.Z, {
                                    value: filterPeriod,
                                    onChange: handleFilterChange,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersByCountryInsight_Option, {
                                            value: "week",
                                            children: t("last_7_days")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersByCountryInsight_Option, {
                                            value: "month",
                                            children: t("last_30_days")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersByCountryInsight_Option, {
                                            value: "quarter",
                                            children: t("last_3_months")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersByCountryInsight_Option, {
                                            value: "year",
                                            children: t("last_year")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default */.Z, {
                    columns: columns,
                    dataSource: filteredStats,
                    loading: loading,
                    pagination: false,
                    rowKey: "country"
                })
            ]
        })
    });
};
/* harmony default export */ var UsersGraphs_UsersByCountryInsight = (UsersByCountryInsight);

;// CONCATENATED MODULE: ./src/features/dashboard/components/UsersGraphs/UsersByPurpose.tsx








const UsersByPurpose = ()=>{
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { data , loading  } = (0,useQuery/* useQuery */.a)(src/* GET_USER_COUNT_BY_PURPOSE */.iDO);
    const highestPurpose = (0,react.useMemo)(()=>{
        let highest = 0;
        let purpose = "";
        for (const item of (data === null || data === void 0 ? void 0 : data.userCountByPurpose) || []){
            if ((item === null || item === void 0 ? void 0 : item.count) > highest) {
                highest = item.count;
                purpose = item.purpose;
            }
        }
        return purpose;
    }, [
        data
    ]);
    const formattedData = (0,react.useMemo)(()=>{
        return data === null || data === void 0 ? void 0 : data.userCountByPurpose.map((item)=>({
                ...item,
                color: item.purpose === highestPurpose ? "#47DA47" : "#529FF0"
            }));
    }, [
        data,
        highestPurpose
    ]);
    const config = {
        data: formattedData || [],
        loading,
        xField: "purpose",
        yField: "count",
        paddingRight: 20,
        colorField: "color",
        scale: {
            color: {
                range: [
                    "#47DA47",
                    "#529FF0"
                ]
            }
        },
        yAxis: {
            label: {
                style: {
                    fontFamily: "Lufga",
                    fill: "rgba(0, 0, 0, 0.65)",
                    textAlign: "right"
                },
                labelFormatter (text) {
                    return (0,util_src/* getLinkLabel */.en)(text);
                }
            }
        },
        tooltip: {
            title: (datum)=>(0,util_src/* getLinkLabel */.en)(datum.purpose),
            formatter: (datum)=>{
                return {
                    name: "count",
                    value: datum.count
                };
            }
        },
        label: {
            text: "count",
            position: "right",
            textAlign: "start",
            dx: 8,
            style: {
                fill: "rgba(0, 0, 0, 0.65)",
                fontFamily: "Lufga"
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-between items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-sm text-gray-900 font-medium",
                                children: t("users_by_onboarding_purpose")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-gray-700 font-normal",
                                children: t("onboarding_purpose_description")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bar/* default */.Z, {
                    ...config
                })
            ]
        })
    });
};
/* harmony default export */ var UsersGraphs_UsersByPurpose = (UsersByPurpose);

;// CONCATENATED MODULE: ./src/features/dashboard/components/UsersGraphs/UsersByRegion.tsx








const { RangePicker: UsersByRegion_RangePicker  } = date_picker/* default */.Z;
const UsersByRegion = ()=>{
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const endDate = dayjs_min_default()();
    const startDate = dayjs_min_default()().subtract(3, "month");
    const [date, setDate] = (0,react.useState)([
        startDate.format("YYYY-MM-DD"),
        endDate.format("YYYY-MM-DD")
    ]);
    const [getData, { data , loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_COUNT_BY_REGION */.O$L);
    const [option, setOption] = (0,react.useState)({
        key: "DESC",
        label: t("highest_to_lowest")
    });
    const options = (0,react.useMemo)(()=>[
            {
                key: "DESC",
                label: t("highest_to_lowest")
            },
            {
                key: "ASC",
                label: t("lowest_to_highest")
            }
        ], [
        t
    ]);
    const highestRegion = (0,react.useMemo)(()=>{
        let highest = 0;
        let region = "";
        for (const item of (data === null || data === void 0 ? void 0 : data.userCountByRegion) || []){
            if ((item === null || item === void 0 ? void 0 : item.count) > highest) {
                highest = item.count;
                region = item.region;
            }
        }
        return region;
    }, [
        data
    ]);
    const config = {
        data: (data === null || data === void 0 ? void 0 : data.userCountByRegion) || [],
        loading,
        xField: "region",
        yField: "count",
        color: (param)=>{
            let { region  } = param;
            if (region === highestRegion) {
                return "#47DA47";
            }
            return "#529FF0";
        },
        appendPadding: [
            0,
            20,
            0,
            0
        ],
        yAxis: {
            label: {
                style: {
                    fontFamily: "Lufga",
                    fill: "rgba(0, 0, 0, 0.65)",
                    textAlign: "right"
                }
            }
        },
        xAxis: {
            label: {
                style: {
                    fontFamily: "Lufga"
                }
            }
        },
        label: {
            text: "count",
            position: "right",
            textAlign: "start",
            dx: 8,
            style: {
                fill: "rgba(0, 0, 0, 0.65)",
                fontFamily: "Lufga"
            }
        }
    };
    const handleChange = (dates, dateStrings)=>{
        if (dates) {
            setDate([
                dateStrings[0],
                dateStrings[1]
            ]);
        }
    };
    (0,react.useEffect)(()=>{
        getData({
            variables: {
                order: option.key === "DESC",
                startDate: date[0],
                endDate: date[1]
            }
        });
    }, [
        date,
        getData,
        option
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
        style: {
            borderRadius: 20
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-sm text-gray-900 font-medium",
                            children: t("users_by_region")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersByRegion_RangePicker, {
                                onChange: handleChange,
                                defaultValue: [
                                    dayjs_min_default()(date[0]),
                                    dayjs_min_default()(date[1])
                                ],
                                style: {
                                    borderRadius: 20
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bar/* default */.Z, {
                    ...config
                })
            ]
        })
    });
};
/* harmony default export */ var UsersGraphs_UsersByRegion = (UsersByRegion);

;// CONCATENATED MODULE: ./src/features/dashboard/components/UsersGraphs/index.tsx









function UsersGraphs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid md:grid-cols-2 gap-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersGraphs_TotalUsers, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersGraphs_UsersByRegion, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersGraphs_UsersByCountry, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersGraphs_UsersByCountryInsight, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersGraphs_UsersByCompanyAffiliation, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersGraphs_PopularTopicsStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersGraphs_TopContributorsStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersGraphs_UsersByPurpose, {})
        ]
    });
}
/* harmony default export */ var components_UsersGraphs = (UsersGraphs);

;// CONCATENATED MODULE: ./src/features/dashboard/components/DashboardGraphs/index.tsx


















const DashboardGraphs = ()=>{
    var ref, ref1;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const router = (0,next_router.useRouter)();
    const { graph  } = router.query;
    const [type, setType] = (0,react.useState)("insights");
    const { data , loading  } = (0,useQuery/* useQuery */.a)(src/* GET_ME */.xFT);
    const handleChangeType = (type)=>{
        router.push({
            query: {
                ...router.query,
                graph: type
            }
        });
    };
    const tagOptions = (0,react.useMemo)(()=>[
            {
                value: "insights",
                label: t("insights")
            },
            {
                value: "users",
                label: t("users")
            },
            {
                value: "companies",
                label: t("companies")
            },
            {
                value: "open-challenges",
                label: t("open_challenges")
            },
            {
                value: "spark-innovation",
                label: t("spark_innovation")
            },
            {
                value: "ideas",
                label: t("ideas")
            },
            {
                value: "innovation-space",
                label: t("innovation_space")
            },
            {
                value: "trend",
                label: t("trend")
            }
        ], [
        t
    ]);
    (0,react.useEffect)(()=>{
        const graphType = graph;
        if (tagOptions.some((option)=>option.value === graphType)) {
            setType(graphType);
        } else {
            setType("insights");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        graph
    ]);
    const renderPage = ()=>{
        switch(type){
            case "insights":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InsightsGraphs, {});
            case "users":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UsersGraphs, {});
            case "open-challenges":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OpenChallengesGraphs, {});
            case "spark-innovation":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IntraChallengesGraphs, {});
            case "ideas":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IdeasGraphs, {});
            case "companies":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompaniesGraphs, {});
            case "trend":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TrendGraphs, {});
            case "innovation-space":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InnovationSpaceGraphs, {});
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UsersGraphs, {});
        }
    };
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "text-center p-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
        className: "w-full",
        direction: "vertical",
        size: "small",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* PageTitle */.V1, {
                title: t("dashboard"),
                description: "".concat(t("welcome")).concat((data === null || data === void 0 ? void 0 : (ref = data.me) === null || ref === void 0 ? void 0 : ref.fullName) ? ", " + (0,util_src/* capFirst */.gC)(data === null || data === void 0 ? void 0 : (ref1 = data.me) === null || ref1 === void 0 ? void 0 : ref1.fullName) + "!" : "")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-4 overflow-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(segmented/* default */.Z, {
                    rootClassName: "overflow-x-auto",
                    options: tagOptions,
                    onChange: handleChangeType,
                    value: type
                })
            }),
            (data === null || data === void 0 ? void 0 : data.me.role) === "ADMIN" ? renderPage() : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    t("go_to"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/intrapreneurship/challenge",
                        className: "text-primary-600",
                        children: t("intrapreneurship_challenge")
                    }),
                    " ",
                    t("to_create_and_manage_new_challenges")
                ]
            })
        ]
    });
};
/* harmony default export */ var components_DashboardGraphs = (DashboardGraphs);

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/index.tsx







const DashboardPage = ()=>{
    const { publicRuntimeConfig  } = config_default()();
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: t("dashboard")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: t("dashboard_description")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "".concat(publicRuntimeConfig.staticFolder, "/favicon.ico")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DashboardGraphs, {})
        ]
    });
};
DashboardPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout/* default */.Z, {
        children: page
    });
};
/* harmony default export */ var pages = (DashboardPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5033,1486,3907,9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);